var _style, _g, _path, _path2, _g2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _g4, _path13, _circle, _path14, _circle2, _g5, _path15, _path16, _path17, _path18, _path19, _rect2, _rect3, _rect4, _path20, _path21, _path22, _path23, _g6, _circle3, _g7, _circle4, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _polygon, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInteractivo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "183.37px",
    height: "122px",
    viewBox: "0 0 183.37 122",
    style: {
      enableBackground: "new 0 0 183.37 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{opacity:0.6;}\r\n\t.st5{fill:url(#SVGID_3_);}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:url(#SVGID_7_);}\r\n\t.st10{fill:url(#SVGID_8_);}\r\n\t.st11{fill:url(#SVGID_9_);}\r\n\t.st12{fill:url(#SVGID_10_);}\r\n\t.st13{fill:url(#SVGID_11_);}\r\n\t.st14{fill:url(#SVGID_12_);}\r\n\t.st15{fill:url(#SVGID_13_);}\r\n\t.st16{opacity:0.6;fill:#FFFFFF;}\r\n\t.st17{fill:#DEC3DF;}\r\n\t.st18{fill:url(#SVGID_14_);}\r\n\t.st19{fill:url(#SVGID_15_);}\r\n\t.st20{fill:url(#SVGID_16_);}\r\n\t.st21{fill:url(#SVGID_17_);}\r\n\t.st22{fill:url(#SVGID_18_);}\r\n\t.st23{fill:url(#SVGID_19_);}\r\n\t.st24{fill:url(#SVGID_20_);}\r\n\t.st25{fill:url(#SVGID_21_);}\r\n\t.st26{opacity:0.76;}\r\n\t.st27{fill:url(#SVGID_22_);}\r\n\t.st28{fill:url(#SVGID_23_);}\r\n\t.st29{fill:url(#SVGID_24_);}\r\n\t.st30{opacity:0.78;fill:#FFFFFF;}\r\n\t.st31{fill:url(#SVGID_25_);}\r\n\t.st32{fill:url(#SVGID_26_);}\r\n\t.st33{fill:url(#SVGID_27_);}\r\n\t.st34{fill:url(#SVGID_28_);}\r\n\t.st35{fill:url(#SVGID_29_);}\r\n\t.st36{fill:url(#SVGID_30_);}\r\n\t.st37{fill:url(#SVGID_31_);}\r\n\t.st38{fill:url(#SVGID_32_);}\r\n\t.st39{fill:url(#SVGID_33_);}\r\n\t.st40{fill:url(#SVGID_34_);}\r\n\t.st41{fill:url(#SVGID_35_);}\r\n\t.st42{fill:url(#SVGID_36_);}\r\n\t.st43{fill:url(#SVGID_37_);}\r\n\t.st44{fill:url(#SVGID_38_);}\r\n\t.st45{fill:url(#SVGID_39_);}\r\n\t.st46{fill:url(#SVGID_40_);}\r\n\t.st47{fill:url(#SVGID_41_);}\r\n\t.st48{fill:url(#SVGID_42_);}\r\n\t.st49{fill:url(#SVGID_43_);}\r\n\t.st50{fill:url(#SVGID_44_);}\r\n\t.st51{fill:url(#SVGID_45_);}\r\n\t.st52{fill:url(#SVGID_46_);}\r\n\t.st53{fill:url(#SVGID_47_);}\r\n\t.st54{fill:url(#SVGID_48_);}\r\n\t.st55{fill:url(#SVGID_49_);}\r\n\t.st56{fill:url(#SVGID_50_);}\r\n\t.st57{fill:url(#SVGID_51_);}\r\n\t.st58{fill:url(#SVGID_52_);}\r\n\t.st59{fill:url(#SVGID_53_);}\r\n\t.st60{fill:url(#SVGID_54_);}\r\n\t.st61{fill:url(#SVGID_55_);}\r\n\t.st62{fill:url(#SVGID_56_);}\r\n\t.st63{fill:url(#SVGID_57_);}\r\n\t.st64{opacity:0.5;fill:url(#SVGID_58_);}\r\n\t.st65{fill:url(#SVGID_59_);}\r\n\t.st66{fill:url(#SVGID_60_);}\r\n\t.st67{fill:url(#SVGID_61_);}\r\n\t.st68{fill:url(#SVGID_62_);}\r\n\t.st69{fill:url(#SVGID_63_);}\r\n\t.st70{fill:url(#SVGID_64_);}\r\n\t.st71{fill:url(#SVGID_65_);}\r\n\t.st72{fill:url(#SVGID_66_);}\r\n\t.st73{fill:url(#SVGID_67_);}\r\n\t.st74{fill:url(#SVGID_68_);}\r\n\t.st75{fill:url(#SVGID_69_);}\r\n\t.st76{fill:url(#SVGID_70_);}\r\n\t.st77{fill:url(#SVGID_71_);}\r\n\t.st78{fill:url(#SVGID_72_);}\r\n\t.st79{fill:url(#SVGID_73_);}\r\n\t.st80{fill:url(#SVGID_74_);}\r\n\t.st81{fill:url(#SVGID_75_);}\r\n\t.st82{fill:url(#SVGID_76_);}\r\n\t.st83{fill:url(#SVGID_77_);}\r\n\t.st84{fill:url(#SVGID_78_);}\r\n\t.st85{fill:url(#SVGID_79_);}\r\n\t.st86{fill:url(#SVGID_80_);}\r\n\t.st87{fill:url(#SVGID_81_);}\r\n\t.st88{fill:url(#SVGID_82_);}\r\n\t.st89{fill:url(#SVGID_83_);}\r\n\t.st90{fill:url(#SVGID_84_);}\r\n\t.st91{fill:url(#SVGID_85_);}\r\n\t.st92{fill:url(#SVGID_86_);}\r\n\t.st93{fill:url(#SVGID_87_);}\r\n\t.st94{fill:url(#SVGID_88_);}\r\n\t.st95{fill:url(#SVGID_89_);}\r\n\t.st96{fill:url(#SVGID_90_);}\r\n\t.st97{fill:url(#SVGID_91_);}\r\n\t.st98{fill:url(#SVGID_92_);}\r\n\t.st99{fill:url(#SVGID_93_);}\r\n\t.st100{fill:url(#SVGID_94_);}\r\n\t.st101{fill:url(#SVGID_95_);}\r\n\t.st102{fill:url(#SVGID_96_);}\r\n\t.st103{fill:url(#SVGID_97_);}\r\n\t.st104{fill:url(#SVGID_98_);}\r\n\t.st105{fill:url(#SVGID_99_);}\r\n\t.st106{fill:url(#SVGID_100_);}\r\n\t.st107{fill:#CB96C3;}\r\n\t.st108{fill:url(#SVGID_101_);}\r\n\t.st109{fill:url(#SVGID_102_);}\r\n\t.st110{fill:url(#SVGID_103_);}\r\n\t.st111{fill:url(#SVGID_104_);}\r\n\t.st112{fill:url(#SVGID_105_);}\r\n\t.st113{fill:url(#SVGID_106_);}\r\n\t.st114{fill:url(#SVGID_107_);}\r\n\t.st115{fill:url(#SVGID_108_);}\r\n\t.st116{fill:url(#SVGID_109_);}\r\n\t.st117{fill:url(#SVGID_110_);}\r\n\t.st118{fill:url(#SVGID_111_);}\r\n\t.st119{fill:url(#SVGID_112_);}\r\n\t.st120{fill:url(#SVGID_113_);}\r\n\t.st121{fill:url(#SVGID_114_);}\r\n\t.st122{fill:url(#SVGID_115_);}\r\n\t.st123{fill:url(#SVGID_116_);}\r\n\t.st124{fill:url(#SVGID_117_);}\r\n\t.st125{fill:url(#SVGID_118_);}\r\n\t.st126{fill:url(#SVGID_119_);}\r\n\t.st127{fill:url(#SVGID_120_);}\r\n\t.st128{opacity:0.53;fill:#FFFFFF;}\r\n\t.st129{fill:url(#SVGID_121_);}\r\n\t.st130{opacity:0.75;fill:#FBE0E5;}\r\n\t.st131{fill:#ECD2D8;}\r\n\t.st132{fill:none;stroke:#E1BFC8;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st133{fill:none;stroke:#E1BFC8;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.9583;}\r\n\t.st134{fill:none;stroke:#E1BFC8;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,3.9765;}\r\n\t.st135{fill:#324D9C;}\r\n\t.st136{fill:#1D3D91;}\r\n\t.st137{fill:#F6DADD;}\r\n\t.st138{fill:#E9C7CB;}\r\n\t.st139{fill:#D48A0A;}\r\n\t.st140{fill:#F2927C;}\r\n\t.st141{fill:#EB836C;}\r\n\t.st142{fill:#F4F2F1;}\r\n\t.st143{fill:#FBB916;}\r\n\t.st144{fill:#F6A318;}\r\n\t.st145{fill:#FEC708;}\r\n\t.st146{fill:#F5B301;}\r\n\t.st147{fill:#232020;}\r\n\t.st148{fill:#020203;}\r\n\t.st149{fill:#3C73B9;}\r\n\t.st150{fill:#366BB3;}\r\n\t.st151{fill:#FFD504;}\r\n\t.st152{fill:#FBB911;}\r\n\t.st153{fill:#FFDB2A;}\r\n\t.st154{fill:#E8F2FA;}\r\n\t.st155{fill:#C9DEF4;}\r\n\t.st156{fill:#DDE9F8;}\r\n\t.st157{fill:#F28F35;}\r\n\t.st158{fill:#ACC0E4;}\r\n\t.st159{fill:#FFF7EF;}\r\n\t.st160{fill:#FDDCC3;}\r\n\t.st161{fill:#F7AD76;}\r\n\t.st162{fill:#1F3865;}\r\n\t.st163{fill:#264790;}\r\n\t.st164{fill:#F39153;}\r\n\t.st165{fill:#91B0DD;}\r\n\t.st166{fill:#EE751B;}\r\n\t.st167{fill:#20396F;}\r\n\t.st168{fill:#EEC09D;}\r\n\t.st169{fill:#EF7A3E;}\r\n\t.st170{fill:#6896CF;}\r\n\t.st171{fill:#4880C1;}\r\n\t.st172{fill:#FDDBBA;}\r\n\t.st173{fill:#144179;}\r\n\t.st174{fill:#EE761C;}\r\n\t.st175{fill:#F39254;}\r\n\t.st176{fill:#2A3967;}\r\n\t.st177{fill:#ACCAEB;}\r\n\t.st178{fill:#EA5A21;}\r\n\t.st179{fill:#F07F26;}\r\n\t.st180{fill:#9FC6EA;}\r\n\t.st181{fill:#E0EFFB;}\r\n\t.st182{fill:#183F73;}\r\n\t.st183{fill:#F59E60;}\r\n\t.st184{fill:#1A3760;}\r\n\t.st185{fill:#0F4E88;}\r\n\t.st186{fill:#AFCCED;}\r\n\t.st187{fill:#2D3555;}\r\n\t.st188{opacity:0.7;}\r\n\t.st189{opacity:0.5;fill:url(#SVGID_122_);}\r\n\t.st190{opacity:0.5;fill:url(#SVGID_123_);}\r\n\t.st191{opacity:0.65;fill:#FFFFFF;}\r\n\t.st192{fill:url(#SVGID_124_);}\r\n\t.st193{opacity:0.57;fill:#FFFFFF;}\r\n\t.st194{fill:url(#SVGID_125_);}\r\n\t.st195{fill:url(#SVGID_126_);}\r\n\t.st196{opacity:0.5;fill:#FFFFFF;}\r\n\t.st197{fill:url(#SVGID_127_);}\r\n\t.st198{fill:url(#SVGID_128_);}\r\n\t.st199{fill:url(#SVGID_129_);}\r\n\t.st200{fill:url(#SVGID_130_);}\r\n\t.st201{fill:url(#SVGID_131_);}\r\n\t.st202{fill:url(#SVGID_132_);}\r\n\t.st203{fill:url(#SVGID_133_);}\r\n\t.st204{fill:url(#SVGID_134_);}\r\n\t.st205{fill:url(#SVGID_135_);}\r\n\t.st206{fill:url(#SVGID_136_);}\r\n\t.st207{opacity:0.69;fill:#FFFFFF;}\r\n\t.st208{fill:url(#SVGID_137_);}\r\n\t.st209{fill:url(#SVGID_138_);}\r\n\t.st210{fill:url(#SVGID_139_);}\r\n\t.st211{fill:url(#SVGID_140_);}\r\n\t.st212{fill:url(#SVGID_141_);}\r\n\t.st213{fill:url(#SVGID_142_);}\r\n\t.st214{fill:url(#SVGID_143_);}\r\n\t.st215{fill:url(#SVGID_144_);}\r\n\t.st216{fill:url(#SVGID_145_);}\r\n\t.st217{fill:url(#SVGID_146_);}\r\n\t.st218{fill:url(#SVGID_147_);}\r\n\t.st219{fill:url(#SVGID_148_);}\r\n\t.st220{fill:url(#SVGID_149_);}\r\n\t.st221{fill:url(#SVGID_150_);}\r\n\t.st222{fill:url(#SVGID_151_);}\r\n\t.st223{opacity:0.72;fill:#FFFFFF;}\r\n\t.st224{fill:url(#SVGID_152_);}\r\n\t.st225{fill:url(#SVGID_153_);}\r\n\t.st226{fill:url(#SVGID_154_);}\r\n\t.st227{fill:url(#SVGID_155_);}\r\n\t.st228{fill:url(#SVGID_156_);}\r\n\t.st229{fill:url(#SVGID_157_);}\r\n\t.st230{fill:url(#SVGID_158_);}\r\n\t.st231{fill:url(#SVGID_159_);}\r\n\t.st232{fill:url(#SVGID_160_);}\r\n\t.st233{fill:url(#SVGID_161_);}\r\n\t.st234{fill:url(#SVGID_162_);}\r\n\t.st235{fill:url(#SVGID_163_);}\r\n\t.st236{fill:url(#SVGID_164_);}\r\n\t.st237{fill:url(#SVGID_165_);}\r\n\t.st238{fill:url(#SVGID_166_);}\r\n\t.st239{fill:url(#SVGID_167_);}\r\n\t.st240{fill:url(#SVGID_168_);}\r\n\t.st241{fill:url(#SVGID_169_);}\r\n\t.st242{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_170_);}\r\n\t.st243{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_171_);}\r\n\t.st244{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_172_);}\r\n\t.st245{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_173_);}\r\n\t.st246{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_174_);}\r\n\t.st247{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_175_);}\r\n\t.st248{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_176_);}\r\n\t.st249{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_177_);}\r\n\t.st250{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_178_);}\r\n\t.st251{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_179_);}\r\n\t.st252{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_180_);}\r\n\t.st253{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_181_);}\r\n\t.st254{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_182_);}\r\n\t.st255{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_183_);}\r\n\t.st256{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_184_);}\r\n\t.st257{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_185_);}\r\n\t.st258{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_186_);}\r\n\t.st259{fill:url(#SVGID_187_);}\r\n\t.st260{fill:url(#SVGID_188_);}\r\n\t.st261{fill:url(#SVGID_189_);}\r\n\t.st262{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_190_);}\r\n\t.st263{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_191_);}\r\n\t.st264{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_192_);}\r\n\t.st265{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_193_);}\r\n\t.st266{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_194_);}\r\n\t.st267{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_195_);}\r\n\t.st268{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_196_);}\r\n\t.st269{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_197_);}\r\n\t.st270{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_198_);}\r\n\t.st271{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_199_);}\r\n\t.st272{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_200_);}\r\n\t.st273{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_201_);}\r\n\t.st274{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_202_);}\r\n\t.st275{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_203_);}\r\n\t.st276{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_204_);}\r\n\t.st277{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_205_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st188"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -799.9689,
    y1: 61,
    x2: -618.6555,
    y2: 61,
    gradientTransform: "matrix(-1 0 0 1 -617.5417 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#937DB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA99C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_1_)"
    },
    d: "M166.69,53.21c4.74-8.64,15.19-16.34,12.73-27.15 c-2.32-10.2-18.13-19.63-28.19-13.66c-6.4,3.81-9.29,9.57-17.48,10.47c-6.27,0.69-14.39,0.3-19.34-3.95 c-3.81-3.27-6.2-6.9-10.91-9.3c-8.16-4.16-18-4.62-27.05-3.79c-13.17,1.2-18.41,14.47-29.82,18.66 C39.64,27.05,31.67,26,24.55,24.5c-6.6-1.39-15.44-5.45-20.46,1.12c-4.82,6.3-3.16,19.06,0.46,25.62 c2.47,4.49,8.41,6.26,10.54,11.06c2.18,4.92-1.24,9.39-4.56,13.02c-7.63,8.34-6.3,33.38,8.65,34.17 c7.15,0.38,14.32-3.08,21.45-1.36c5.84,1.41,9.62,6.73,15.8,7.33c5.87,0.57,11.53-0.55,16.87-2.81c6.05-2.56,11.71-5.77,18.43-6.5 c6.36-0.69,13.31-0.16,19.66,0.52c5.39,0.59,10.71,1.71,15.75,3.61c4.78,1.8,9.27,5.05,14.49,5.54 c12.16,1.14,27.94,1.94,36.73-7.79c5.42-6.01,5.19-15.1,0.67-21.51c-2.72-3.86-8.16-4.79-10.62-8.25 C164.51,72.8,163.42,59.18,166.69,53.21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -796.2139,
    y1: 62.1319,
    x2: -622.352,
    y2: 62.1319,
    gradientTransform: "matrix(-1 0 0 1 -617.5417 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#937DB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA99C4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_2_)"
    },
    d: "M163.58,54.84c3.67-6.54,10.59-11.92,12.18-19.38 c1.49-6.99-2.85-13.16-9.01-16.91c-5.82-3.55-12.29-4.72-18.58-1.46c-5.69,2.95-9.2,8.58-16.18,9.33 c-6.01,0.65-13.79,0.28-18.54-3.7c-3.65-3.06-5.94-6.46-10.46-8.71c-7.83-3.9-17.26-4.32-25.94-3.55 C64.42,11.57,59.4,24.01,48.46,27.93c-6.71,2.4-14.34,1.41-21.17,0.01c-6.33-1.3-14.8-5.1-19.62,1.05 C3.05,34.9,4.64,46.84,8.11,53c2.37,4.21,8.06,5.86,10.11,10.37c2.09,4.61-1.19,8.8-4.37,12.2c-7.32,7.82-6.04,31.27,8.29,32.01 c6.86,0.35,13.74-2.88,20.56-1.27c5.6,1.32,9.23,6.31,15.15,6.87c5.63,0.53,11.06-0.51,16.17-2.63c5.8-2.4,11.23-5.41,17.67-6.09 c6.1-0.64,12.77-0.15,18.85,0.49c5.17,0.55,10.27,1.6,15.11,3.39c4.58,1.69,8.89,4.73,13.9,5.19c11.66,1.07,26.8,1.82,35.22-7.3 c5.2-5.63,4.98-14.15,0.64-20.15c-2.61-3.62-7.83-4.49-10.18-7.73C161.49,73.19,160.45,60.43,163.58,54.84z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M176.32,21.53c-0.6-2.83-2.08-1.86-4.57-2.73c-2.49-0.87-1.76-3.98-3.3-4.94 c-2.06-1.28-3.95-0.09-5.23,1.59c-2.13,2.79-3.58,0.52-6.13,1.65c-1.46,0.65-0.84,1.56-2.81,1.92c-1.38,0.26-2.87-0.35-4.23,0.02 c-1.01,0.27-1.73,0.75-1.96,1.72c0.28,0.13,0.58,0.25,0.88,0.36c3.8,1.37,8.99,0.91,12.83,1.11 C163.11,22.3,176.75,23.54,176.32,21.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M155.38,30.36c-1-1.22-2.5-1.73-3.96-1.36c-1.6,0.4-2.5,1.92-3.98,2.54c-2.59,1.06-6.18-1.04-8.15,1.71 c-2.41,3.36-4.27,0.84-4.27,3.12c0,2.28,16.64,0.6,24.84,0.72c1.19,0.02,6.33-0.07,4.12-2.53c-0.69-0.76-1.67-0.89-2.59-1.07 c-1.19-0.23-4.03-0.36-4.9-1.29c-0.47-0.5-0.64-1.22-1.06-1.75C155.41,30.41,155.39,30.39,155.38,30.36z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 909.9076,
    y1: 124.9463,
    x2: 888.1603,
    y2: 39.7048,
    gradientTransform: "matrix(0.9786 -0.2056 0.2051 0.9763 -844.502 177.2752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7569A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9163A7"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.69,70.42c-1.73-8.23-5.98-15.08-11.4-19.41c-4.84-3.87-8.05-9.45-8.83-15.59 c-0.08-0.65-0.19-1.3-0.33-1.95c-2.08-9.89-9.83-16.64-17.3-15.07c-7.48,1.57-11.86,10.86-9.78,20.76 c0.42,2.02,1.09,3.91,1.94,5.63c2.71,5.47,3.35,11.77,1.57,17.61c-1.6,5.22-1.91,11.25-0.61,17.42 c1.93,9.2,7.02,16.68,13.37,20.83c2.4,1.57,4.51,3.57,6.18,5.89c2.79,3.86,7.05,5.98,11.25,5.1c4.53-0.95,7.72-5.13,8.44-10.31 c0.41-2.93,1.39-5.75,2.79-8.36C76.26,86.8,77.44,78.73,75.69,70.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M42.66,28.37c2.35,6.33,4.5,12.74,6.57,19.16c0.52,1.61,1.01,3.22,1.51,4.83l0.75,2.42l0.73,2.43 c0.48,1.62,0.98,3.23,1.44,4.86l1.38,4.87c0.88,3.26,1.79,6.51,2.61,9.79c0.41,1.64,0.86,3.27,1.24,4.91l1.16,4.93 c1.48,6.59,2.8,13.22,3.77,19.91l-0.29,0.04l-0.92-4.97l-0.23-1.24l-0.26-1.24l-0.52-2.47l-0.52-2.48 c-0.17-0.83-0.37-1.64-0.56-2.47c-0.38-1.64-0.75-3.29-1.14-4.93c-1.61-6.55-3.3-13.08-5.13-19.57 c-0.94-3.24-1.85-6.49-2.81-9.72l-0.71-2.43l-0.73-2.42c-0.49-1.61-0.98-3.23-1.48-4.84c-0.98-3.23-1.99-6.45-3.02-9.66 c-1.02-3.22-2.06-6.43-3.12-9.63L42.66,28.37z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.98,46.68c-0.07-0.01-0.13-0.06-0.17-0.12c-4.41-8-3.7-14.02-2.33-17.66c1.49-3.96,4-5.98,4.1-6.06 c0.11-0.08,0.26-0.07,0.34,0.04c0.08,0.11,0.07,0.26-0.04,0.34c-0.03,0.02-2.52,2.04-3.96,5.88c-1.33,3.54-2.01,9.4,2.31,17.23 c0.07,0.12,0.02,0.27-0.1,0.33C34.09,46.68,34.03,46.69,33.98,46.68z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1469.9348,
    y1: -5137.541,
    x2: 1457.7413,
    y2: -5185.335,
    gradientTransform: "matrix(0.8044 -0.5941 0.5941 0.8044 1921.593 5116.7871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.13,88.56c-2.81-3.8-6.58-6.31-10.36-7.26c-3.38-0.85-6.32-2.95-8.15-5.91 c-0.19-0.31-0.4-0.62-0.62-0.92c-3.38-4.57-8.91-6.21-12.35-3.67c-3.45,2.55-3.5,8.31-0.13,12.88c0.69,0.93,1.47,1.75,2.3,2.43 c2.66,2.17,4.46,5.23,4.92,8.63c0.41,3.04,1.66,6.19,3.76,9.04c3.14,4.25,7.48,6.89,11.69,7.53c1.59,0.24,3.13,0.77,4.53,1.57 c2.33,1.32,4.99,1.42,6.93-0.01c2.09-1.54,2.74-4.42,1.89-7.24c-0.48-1.59-0.64-3.26-0.54-4.92 C48.25,96.8,46.96,92.4,44.13,88.56z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M17.44,74.77c2.68,2.69,5.27,5.46,7.84,8.26c0.64,0.7,1.27,1.41,1.9,2.12l0.95,1.06l0.94,1.07 c0.62,0.72,1.26,1.42,1.87,2.14l1.85,2.17c1.21,1.46,2.44,2.91,3.62,4.39c0.59,0.74,1.2,1.47,1.78,2.22l1.75,2.25 c2.3,3.02,4.52,6.1,6.58,9.29l-0.14,0.09l-1.63-2.33l-0.41-0.58l-0.42-0.57l-0.85-1.14l-0.84-1.14 c-0.28-0.38-0.57-0.75-0.86-1.13c-0.58-0.75-1.15-1.51-1.73-2.25c-2.35-2.97-4.74-5.91-7.2-8.8c-1.24-1.44-2.46-2.88-3.71-4.31 L27.8,86.5l-0.94-1.07c-0.63-0.71-1.25-1.42-1.89-2.13c-1.26-1.42-2.52-2.83-3.8-4.23c-1.27-1.41-2.56-2.8-3.84-4.19 L17.44,74.77z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.32,85.75c-0.04,0.01-0.09,0.01-0.12-0.02c-4.56-3.02-5.86-6.42-6.14-8.73 c-0.31-2.51,0.46-4.28,0.49-4.36c0.03-0.07,0.12-0.11,0.19-0.07c0.07,0.03,0.11,0.12,0.07,0.19c-0.01,0.02-0.77,1.78-0.47,4.22 c0.28,2.25,1.55,5.55,6.01,8.51c0.07,0.04,0.09,0.14,0.04,0.2C18.38,85.72,18.35,85.74,18.32,85.75z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1308.5342,
    y1: 206.8416,
    x2: 1290.5786,
    y2: 136.4623,
    gradientTransform: "matrix(-0.9786 -0.2056 -0.2051 0.9763 1441.0619 177.2752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7569A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9163A7"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M114.7,75.69c1.43-6.79,4.94-12.45,9.41-16.02c4-3.19,6.65-7.8,7.29-12.87c0.07-0.53,0.16-1.07,0.27-1.61 c1.72-8.17,8.11-13.74,14.29-12.44c6.17,1.3,9.79,8.97,8.07,17.14c-0.35,1.67-0.9,3.23-1.6,4.65 c-2.24,4.52-2.77,9.72-1.29,14.54c1.32,4.31,1.58,9.29,0.51,14.38c-1.6,7.59-5.8,13.77-11.04,17.2c-1.98,1.3-3.72,2.95-5.1,4.87 c-2.3,3.19-5.82,4.94-9.28,4.21c-3.74-0.79-6.37-4.24-6.97-8.52c-0.34-2.42-1.15-4.75-2.3-6.9 C114.23,89.22,113.25,82.56,114.7,75.69z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M141.97,40.98c-1.94,5.23-3.71,10.52-5.43,15.82c-0.43,1.33-0.84,2.66-1.25,3.99l-0.62,2l-0.6,2 c-0.4,1.34-0.81,2.67-1.19,4.01l-1.14,4.02c-0.73,2.69-1.48,5.38-2.16,8.08c-0.34,1.35-0.71,2.7-1.02,4.06l-0.96,4.07 c-1.22,5.44-2.31,10.92-3.12,16.44l0.24,0.04l0.76-4.11l0.19-1.03l0.21-1.02l0.43-2.04l0.43-2.04c0.14-0.68,0.31-1.36,0.46-2.04 c0.31-1.36,0.62-2.71,0.94-4.07c1.33-5.41,2.73-10.8,4.24-16.16c0.78-2.67,1.53-5.36,2.32-8.03l0.59-2l0.61-2 c0.4-1.33,0.81-2.67,1.22-3.99c0.81-2.66,1.64-5.32,2.5-7.97c0.84-2.66,1.7-5.31,2.57-7.95L141.97,40.98z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M149.13,56.09c0.06-0.01,0.11-0.05,0.14-0.1c3.64-6.61,3.05-11.58,1.92-14.58 c-1.23-3.27-3.3-4.94-3.39-5.01c-0.09-0.07-0.21-0.06-0.28,0.03c-0.07,0.09-0.06,0.21,0.03,0.28c0.02,0.02,2.08,1.68,3.27,4.85 c1.1,2.92,1.66,7.76-1.9,14.22c-0.05,0.1-0.02,0.22,0.08,0.28C149.04,56.1,149.09,56.1,149.13,56.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.0893,
    y1: -5905.2314,
    x2: 422.5782,
    y2: -5950.3506,
    gradientTransform: "matrix(-0.8044 -0.5941 -0.5941 0.8044 -3025.033 5116.7871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C4997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA4B7B"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M141.32,87.67c2.65-3.59,6.21-5.96,9.78-6.85c3.19-0.8,5.97-2.79,7.7-5.58c0.18-0.29,0.38-0.58,0.59-0.87 c3.19-4.31,8.41-5.87,11.66-3.46c3.25,2.4,3.31,7.85,0.12,12.16c-0.65,0.88-1.39,1.65-2.18,2.29c-2.51,2.04-4.21,4.94-4.65,8.15 c-0.39,2.87-1.57,5.85-3.55,8.54c-2.96,4.01-7.07,6.5-11.04,7.11c-1.5,0.23-2.96,0.73-4.28,1.48c-2.2,1.25-4.71,1.34-6.54-0.01 c-1.97-1.46-2.58-4.17-1.78-6.83c0.45-1.5,0.6-3.08,0.51-4.65C137.43,95.45,138.65,91.3,141.32,87.67z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M166.52,74.66c-2.53,2.54-4.98,5.15-7.4,7.8c-0.61,0.66-1.2,1.33-1.8,2l-0.9,1l-0.89,1.01 c-0.59,0.68-1.19,1.34-1.77,2.02l-1.74,2.05c-1.14,1.38-2.3,2.75-3.42,4.15c-0.56,0.7-1.13,1.39-1.68,2.1l-1.65,2.12 c-2.17,2.85-4.27,5.76-6.22,8.77l0.13,0.09l1.54-2.2l0.38-0.55l0.4-0.54l0.8-1.08l0.8-1.08c0.26-0.36,0.54-0.71,0.81-1.07 c0.55-0.71,1.09-1.42,1.64-2.13c2.22-2.81,4.48-5.58,6.79-8.31c1.17-1.36,2.32-2.72,3.5-4.07l0.88-1.01l0.89-1.01 c0.59-0.67,1.18-1.34,1.78-2.01c1.19-1.34,2.38-2.67,3.59-3.99c1.2-1.33,2.41-2.65,3.63-3.96L166.52,74.66z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M165.68,85.02c0.04,0.01,0.08,0.01,0.12-0.02c4.31-2.85,5.53-6.06,5.79-8.24 c0.29-2.37-0.44-4.04-0.47-4.11c-0.03-0.07-0.11-0.1-0.18-0.07c-0.07,0.03-0.1,0.11-0.07,0.18c0.01,0.02,0.73,1.68,0.44,3.98 c-0.26,2.12-1.46,5.24-5.67,8.03c-0.06,0.04-0.08,0.13-0.04,0.19C165.63,84.99,165.65,85.01,165.68,85.02z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.4221,
    y1: 126.4535,
    x2: 99.8626,
    y2: 97.1536
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.98,
    y: 102.07,
    className: "st9",
    width: 9.58,
    height: 9.58
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -1549.1788,
    y1: 99.4111,
    x2: -1524.9615,
    y2: 26.7591,
    gradientTransform: "matrix(-1 0 0 1 -1447.7645 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M38.88,102.05c0,1.04,0.85,1.89,1.9,1.89h102.54c1.04,0,1.9-0.85,1.9-1.89l0.85-58.93 c0-1.04-1.23-3.08-3.48-2.92L42.38,37.6c-1.31-0.03-2.57,0.47-3.5,1.39c-0.93,0.92-1.43,2.19-1.4,3.49L38.88,102.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.565,
    y1: 57.1091,
    x2: 88.2499,
    y2: 136.6718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3B58A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#2A3071"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M40.76,99.15c0,0.97,0.81,1.76,1.79,1.76h98.3c0.99,0,1.79-0.79,1.79-1.76l0.81-52.6 c-0.09-3.17-2.92-4.3-4.63-4.24l-96.05-2.53c-0.92-0.02-1.81,0.32-2.46,0.96c-0.65,0.64-1.01,1.51-0.98,2.42L40.76,99.15z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.58,74.8C141.58,74.8,141.57,74.8,141.58,74.8c-0.14,0-0.25-0.11-0.24-0.25l0.06-4.34 c0-0.13,0.11-0.23,0.25-0.24c0.13,0,0.24,0.11,0.24,0.25l-0.06,4.34C141.82,74.69,141.71,74.8,141.58,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.73,64.17C141.73,64.17,141.73,64.17,141.73,64.17c-0.14,0-0.25-0.11-0.24-0.25l0.24-16.62 c0-0.99-0.31-1.79-0.9-2.35c-1.1-1.05-2.85-1-2.92-1l-30.7-0.82c-0.13,0-0.24-0.12-0.24-0.25c0-0.13,0.11-0.24,0.24-0.24 c0,0,0,0,0.01,0l30.68,0.82c0.19-0.01,2.03-0.04,3.26,1.13c0.69,0.66,1.04,1.57,1.05,2.7l-0.24,16.62 C141.97,64.06,141.87,64.17,141.73,64.17z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.5736,
    y1: 108.5339,
    x2: 91.935,
    y2: 116.8235
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M114.65,109.99H69.13c-0.9,0-1.63,0.7-1.63,1.6c0,0.76,0.62,1.35,1.38,1.35h45.77 c0.76,0,1.24-0.62,1.24-1.38v-0.24C115.89,110.55,115.42,109.99,114.65,109.99z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 106.0086,
    y1: 16.9316,
    x2: 126.4695,
    y2: 16.9316
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 116.24,
    cy: 16.93,
    r: 10.23
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.02,10.57c-0.28-0.1-0.58,0.11-0.58,0.41v0.62v1.21v6.02c-0.59-0.49-1.42-0.79-2.35-0.79 c-1.81,0-3.27,1.17-3.27,2.62c0,1.45,1.47,2.62,3.27,2.62c1.81,0,3.27-1.17,3.27-2.62c0-0.01,0-0.02,0-0.04h0v-7.8 c1.3,0.2,2.18,1.18,2.69,1.98c0.22,0.34,0.74,0.17,0.71-0.23C121.64,12.14,119.17,10.98,118.02,10.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.0714,
    y1: 16.9688,
    x2: 77.5323,
    y2: 16.9688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 67.3,
    cy: 16.97,
    r: 10.23
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.09,22.33c0,0.2-0.16,0.37-0.37,0.37H61.02c-0.2,0-0.37-0.16-0.37-0.37v-10.5c0-0.2,0.16-0.37,0.37-0.37 h12.71c0.2,0,0.37,0.16,0.37,0.37V22.33z M61.38,21.96h11.97V12.2H61.38V21.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.7,15.3c-0.1-0.13-0.27-0.21-0.44-0.21c-0.17,0-0.33,0.07-0.43,0.2l-2.71,3.42 c-0.09,0.12-0.23,0.19-0.38,0.2c-0.15,0.01-0.3-0.04-0.41-0.14l-2.07-1.93c-0.2-0.19-0.49-0.19-0.69-0.01l-2.55,2.34v3.15h12.71 v-3.15L70.7,15.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 64.4,
    cy: 14.19,
    r: 1.3
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.5295,
    y1: 58.4034,
    x2: 90.7928,
    y2: 171.4748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M127.21,88.01l-71.59-1.74c-1.23-0.03-2.21-1.04-2.21-2.27V48.53c0-1.25,1.01-2.27,2.27-2.27h70.58 c1.23,0,2.23,0.98,2.27,2.2l1.02,37.21C129.57,86.98,128.51,88.04,127.21,88.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.3266,
    y1: 69.5425,
    x2: 91.4452,
    y2: 81.989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M53.41,78.59V84c0,1.23,0.98,2.24,2.21,2.27l71.59,1.74c1.3,0.03,2.36-1.03,2.32-2.33l-0.19-7.09H53.41z"
  }))), /*#__PURE__*/React.createElement("g", null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M55.54,82.57l0.07,0.65c0.06,0.6,0.56,1.05,1.16,1.05H120c0.65,0,1.17-0.52,1.17-1.17l0,0 c0-0.64-0.52-1.16-1.16-1.17l-63.29-0.65C56.02,81.27,55.47,81.87,55.54,82.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.0199,
    y1: 74.7599,
    x2: 46.031,
    y2: 95.7263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M96,83.52c-0.07-0.61-0.16-1.22-0.25-1.84l-39.04-0.4c-0.7-0.01-1.25,0.59-1.18,1.29l0.07,0.65 c0.06,0.6,0.56,1.05,1.16,1.05h39.34C96.07,84.01,96.03,83.76,96,83.52z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M98.43,82.92c0,1.17-0.95,2.12-2.12,2.12c-1.17,0-2.12-0.95-2.12-2.12c0-1.17,0.95-2.12,2.12-2.12 C97.49,80.8,98.43,81.75,98.43,82.92z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122.62,
    y: 81.37,
    className: "st207",
    width: 1.26,
    height: 2.87
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126.07,
    y: 80.57,
    className: "st207",
    width: 1.26,
    height: 3.67
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124.46,
    y: 79.88,
    className: "st207",
    width: 1.15,
    height: 4.36
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M53.38,90.78l0.06,6.07c0.01,0.87,0.72,1.57,1.59,1.56l72.18-0.7c0.87-0.01,1.57-0.72,1.56-1.59L128.73,92 c-0.01-0.85-0.69-1.54-1.55-1.56l-72.2-1.26C54.1,89.17,53.37,89.89,53.38,90.78z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M109.96,92.88H56.19c-0.32,0-0.58-0.26-0.58-0.58v-0.26c0-0.32,0.26-0.58,0.58-0.58h53.77 c0.32,0,0.58,0.26,0.58,0.58v0.26C110.54,92.62,110.28,92.88,109.96,92.88z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M93.92,94.6H56.06c-0.25,0-0.45-0.2-0.45-0.45v-0.2c0-0.25,0.2-0.45,0.45-0.45h37.87 c0.25,0,0.45,0.2,0.45,0.45v0.2C94.37,94.4,94.17,94.6,93.92,94.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M76.32,96.33H55.93c-0.18,0-0.32-0.14-0.32-0.32v-0.14c0-0.18,0.14-0.32,0.32-0.32h20.39 c0.18,0,0.32,0.14,0.32,0.32v0.14C76.64,96.18,76.49,96.33,76.32,96.33z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.89,64.04l-8.54-4.93c-0.1-0.06-0.2-0.06-0.3,0c-0.1,0.06-0.14,0.16-0.14,0.28v9.86 c0,0.12,0.04,0.22,0.14,0.28c0.1,0.06,0.21,0.06,0.31,0l8.54-4.93c0.1-0.06,0.16-0.16,0.16-0.28 C97.05,64.2,96.99,64.1,96.89,64.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.44,73.42c-5.02,0-9.11-4.09-9.11-9.11s4.09-9.11,9.11-9.11c5.02,0,9.11,4.09,9.11,9.11 S96.46,73.42,91.44,73.42z M91.44,55.72c-4.74,0-8.6,3.86-8.6,8.6c0,4.74,3.86,8.6,8.6,8.6s8.6-3.86,8.6-8.6 C100.04,59.57,96.18,55.72,91.44,55.72z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.4832,
    y1: 28.7512,
    x2: 36.9441,
    y2: 28.7512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 26.71,
    cy: 28.75,
    r: 10.23
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.5,31.8l-0.61-3.88c0-0.34-0.05-0.67-0.15-0.98l-0.03-0.17l-0.03,0.04c-0.46-1.22-1.63-2.09-3.02-2.09h-7 c-1.78,0-3.22,1.43-3.22,3.21c0,0.24,0.03,0.46,0.08,0.68l-0.5,3.18c-0.04,0.25,0.03,0.52,0.2,0.71 c0.17,0.19,0.41,0.31,0.66,0.31h1.01c0.48,0,0.94-0.15,1.33-0.43l1.71-1.23h4.66l1.71,1.23c0.39,0.28,0.85,0.43,1.33,0.43h1.01 c0.25,0,0.5-0.12,0.66-0.32C34.47,32.31,34.54,32.05,34.5,31.8z M23.8,29.89c-1.1,0-2-0.89-2-1.99c0-1.1,0.89-2,2-2s2,0.89,2,2 C25.79,28.99,24.9,29.89,23.8,29.89z M30.43,29.89c-1.1,0-2-0.89-2-1.99c0-1.1,0.89-2,2-2c1.1,0,2,0.89,2,2 C32.42,28.99,31.53,29.89,30.43,29.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.73,27.48h-0.55v-0.62c0-0.18-0.2-0.3-0.37-0.3h-0.09c-0.18,0-0.27,0.12-0.27,0.3v0.62H22.8 c-0.18,0-0.27,0.12-0.27,0.3v0.09c0,0.18,0.09,0.34,0.27,0.34h0.65v0.58c0,0.18,0.09,0.34,0.27,0.34h0.09 c0.18,0,0.37-0.17,0.37-0.34v-0.58h0.55c0.18,0,0.37-0.17,0.37-0.34v-0.09C25.11,27.61,24.91,27.48,24.73,27.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31,26.93c0,0.2-0.16,0.37-0.37,0.37l0,0c-0.2,0-0.37-0.16-0.37-0.37l0,0c0-0.2,0.16-0.37,0.37-0.37l0,0 C30.83,26.56,31,26.73,31,26.93L31,26.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31,28.96c0,0.2-0.16,0.37-0.37,0.37l0,0c-0.2,0-0.37-0.16-0.37-0.37l0,0c0-0.2,0.16-0.37,0.37-0.37l0,0 C30.83,28.59,31,28.75,31,28.96L31,28.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.92,27.85c0,0.2-0.16,0.37-0.37,0.37l0,0c-0.2,0-0.37-0.16-0.37-0.37l0,0c0-0.2,0.16-0.37,0.37-0.37 l0,0C31.76,27.48,31.92,27.65,31.92,27.85L31.92,27.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.89,27.85c0,0.2-0.16,0.37-0.37,0.37l0,0c-0.2,0-0.37-0.16-0.37-0.37l0,0c0-0.2,0.16-0.37,0.37-0.37 l0,0C29.73,27.48,29.89,27.65,29.89,27.85L29.89,27.85z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.5967,
    y1: 24.3356,
    x2: 167.0577,
    y2: 24.3356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 156.83,
    cy: 24.34,
    r: 10.23
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.59,17.91h-13.44v12.15h13.44V17.91z M151.99,19.98c0,0.08-0.06,0.14-0.14,0.14h-1.2 c-0.07,0-0.14-0.06-0.14-0.14V18.6c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14V19.98z M154.2,19.98 c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V18.6c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14 V19.98z M156.41,19.98c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V18.6c0-0.08,0.06-0.14,0.14-0.14h1.2 c0.07,0,0.14,0.06,0.14,0.14V19.98z M158.43,19.98c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V18.6 c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14V19.98z M160.64,19.98c0,0.08-0.06,0.14-0.14,0.14h-1.2 c-0.07,0-0.14-0.06-0.14-0.14V18.6c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14V19.98z M162.85,19.98 c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V18.6c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14 V19.98z M151.99,29.19c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V27.8c0-0.08,0.06-0.14,0.14-0.14h1.2 c0.07,0,0.14,0.06,0.14,0.14V29.19z M154.2,29.19c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V27.8 c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14V29.19z M156.41,29.19c0,0.08-0.06,0.14-0.14,0.14h-1.2 c-0.07,0-0.14-0.06-0.14-0.14V27.8c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14V29.19z M158.43,29.19 c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V27.8c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14 V29.19z M160.64,29.19c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V27.8c0-0.08,0.06-0.14,0.14-0.14h1.2 c0.07,0,0.14,0.06,0.14,0.14V29.19z M162.85,29.19c0,0.08-0.06,0.14-0.14,0.14h-1.2c-0.07,0-0.14-0.06-0.14-0.14V27.8 c0-0.08,0.06-0.14,0.14-0.14h1.2c0.07,0,0.14,0.06,0.14,0.14V29.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.5613,
    y1: 114.6441,
    x2: 182.4028,
    y2: 86.7341,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M156.84,89.2l3.84,0.96l-0.96,7.2c0,0,1.44,1.44,1.92,3.36c0.48,1.92,0.92,9.98,0.92,9.98l0.91,0.55 l0.11,0.46l-2.65,3.56l0.44-2.84c0.07-0.45-0.05-1.36-0.01-1.38c-1.44-3.84-4.52-14.66-4.52-14.66V89.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.3966,
    y1: 204.4185,
    x2: 207.2295,
    y2: -214.3792,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M155.72,111.76c0.04,0,0.08,0,0.12,0c-0.19-2.32-1.03-12.5-1.88-16.32c-0.96-4.32,1.44-12.96,1.44-12.96 l4.32,4.32l-2.4,8.16c1.64,2.47-0.27,16.92-0.23,16.91l0,0.03l0.63,0.86l-0.08,0.47l-3.83,2.26l1.51-2.44 C155.56,112.66,155.69,112.22,155.72,111.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.6846,
    y1: 70.4906,
    x2: 177.2801,
    y2: 70.4906,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M160.58,63.32c0,0,8.41,9.48,0,14.34l-0.86-0.62c0,0,4.18-4,0-8.89L160.58,63.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -2553.9231,
    y1: 106.9472,
    x2: -2557.9443,
    y2: 113.7524,
    gradientTransform: "matrix(1 0 0 1 2714.4954 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M153.56,115.84h1.22c0.23,0,0.44-0.1,0.58-0.29c0.38-0.49,1.17-1.46,1.55-1.48 c0.51-0.03,0.44,1.77,0.44,1.77h0.28l0.36-2.24c0.09-0.56-0.19-1.12-0.7-1.39l0,0c0,0-0.12,0.86-0.75,1.24 c-0.63,0.38-2.56,1.74-2.56,1.74s-0.24-0.03-0.5,0.01C153.12,115.27,153.17,115.84,153.56,115.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -3770.3179,
    y1: -721.3814,
    x2: -3774.3389,
    y2: -714.5765,
    gradientTransform: "matrix(0.9218 -0.3878 0.3878 0.9218 3919.0813 -692.374)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M160.84,115.7l1.13-0.47c0.21-0.09,0.37-0.27,0.43-0.49c0.16-0.6,0.51-1.8,0.85-1.97 c0.45-0.23,1.09,1.46,1.09,1.46l0.26-0.11l-0.54-2.21c-0.14-0.56-0.61-0.96-1.18-1.01l0,0c0,0,0.23,0.84-0.21,1.43 c-0.43,0.59-1.69,2.6-1.69,2.6s-0.23,0.06-0.45,0.2C160.21,115.35,160.48,115.85,160.84,115.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.1011,
    y1: 71.9084,
    x2: 174.6603,
    y2: 96.3324,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M154.3,75.18c0,0,0.14,0.87-0.07,3.24c-0.21,2.38-1.2,7.96-0.99,13.31c0,0,2.81,0.65,7.69,0.34 c0,0,2.06-8.34,1.56-11.51c-0.5-3.17-3.23-5.45-3.23-5.45L154.3,75.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.7034,
    y1: 60.2371,
    x2: 180.9672,
    y2: 60.2371,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "156.38,59.28 156.03,63.32 159.3,63.32 158.49,57.15  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.5837,
    y1: 63.7733,
    x2: 166.3004,
    y2: 85.946,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M160.26,62.76c-1.13-0.06-3.64-0.18-5.43-0.08c-0.94,0.05-1.73,0.73-1.92,1.65l-0.44,2.09 c-0.16,0.78-0.14,1.58,0.07,2.35l1.75,6.42c0,0,1.55,0.93,4.97-0.07c0,0,3-7.15,1.77-11.72 C160.94,63.04,160.63,62.78,160.26,62.76z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.8528,
    y1: 62.0979,
    x2: 168.6246,
    y2: 78.2693,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M153,63.95c-0.48,1.27-0.91,2.59-1.38,3.84c-0.24,0.62-0.48,1.23-0.74,1.79c-0.13,0.28-0.27,0.54-0.4,0.77 c-0.13,0.23-0.28,0.42-0.36,0.51c-0.02,0.01,0.04,0.02,0.05,0.02c0.01,0-0.32,0.05-0.43,0.07l-0.4,0 c-0.58-0.03-1.23-0.13-1.88-0.26c-1.32-0.25-2.69-0.59-4.1-0.85l-0.01,0c-0.27-0.05-0.53,0.13-0.58,0.4 c-0.03,0.18,0.03,0.35,0.16,0.46c0.57,0.5,1.17,0.91,1.79,1.31c0.31,0.19,0.63,0.38,0.96,0.56c0.33,0.17,0.66,0.34,1.01,0.5 c0.7,0.3,1.41,0.58,2.24,0.76c0.22,0.04,0.43,0.07,0.66,0.1c0.25,0.01,0.48,0.03,0.75,0.02c0.15-0.01,0.29-0.03,0.44-0.05 c0.08-0.01,0.13-0.02,0.23-0.04c0.1-0.03,0.2-0.06,0.3-0.1c0.21-0.07,0.34-0.16,0.51-0.26c0.14-0.09,0.26-0.19,0.39-0.28 c0.45-0.39,0.73-0.77,0.98-1.13c0.25-0.37,0.44-0.73,0.62-1.09c0.35-0.72,0.63-1.43,0.85-2.15c0.45-1.44,0.76-2.85,0.89-4.35 c0.06-0.72-0.47-1.35-1.19-1.41c-0.6-0.05-1.13,0.3-1.33,0.84L153,63.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.6576,
    y1: 66.9939,
    x2: 171.4294,
    y2: 83.1653,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M143.81,70.49l-0.58-1.38l-3.07-0.76c0,0-0.25,0.53,1.04,0.76c0,0-0.46,0.51-0.21,1.11 C141.23,70.81,143.84,71.41,143.81,70.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.1395,
    y1: 60.2358,
    x2: 176.797,
    y2: 50.9614,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M154.99,54.62c-0.12,0.07-1.03,3.31-0.27,4.67c0.77,1.36,3.12-0.16,3.76-2.13 C159.12,55.19,158.1,52.78,154.99,54.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.3518,
    y1: 62.7888,
    x2: 183.0174,
    y2: 62.7888,
    gradientTransform: "matrix(-1 0 0 1 337.0002 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M161.08,57.15c0.53,2.58,2.27,1.88,3.51,3.02c2,1.86,4.87-0.06,7.66,1.71c2.01,1.27,2.98,4.53,2.02,7.16 c-1.34,3.64-5.91,5.14-8.28,4.03c-2.26-1.06-1.94-4.24-4.99-5.47c-1.29-0.52-1.93-0.18-2.71-0.96c-1.36-1.35-0.99-3.98-0.85-4.99 c0.31-2.19,1.04-2.59,0.69-3.56c-0.68-1.88-3.87-1.49-4.14-2.81c-0.24-1.21,2.07-3.49,4.25-3.13 C161.61,52.73,160.85,56,161.08,57.15z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M173.27,68.43c0.04,0,0.08-0.03,0.09-0.07c0.43-1.79,0.24-3.26-0.58-4.36c-1.36-1.83-3.99-2.01-4.02-2.02 c-0.04-0.01-0.09,0.03-0.09,0.08c0,0.05,0.03,0.09,0.08,0.09c0.03,0,2.58,0.18,3.89,1.95c0.78,1.06,0.97,2.48,0.55,4.21 c-0.01,0.05,0.02,0.09,0.07,0.11C173.25,68.43,173.26,68.43,173.27,68.43z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M164.64,70.07c0,0,0.01,0,0.01,0c0.02-0.01,0.04-0.03,0.03-0.05c-0.42-1.61-1.16-2.73-2.19-3.32 c-0.75-0.43-1.45-0.47-2.08-0.51c-0.6-0.03-1.12-0.06-1.53-0.43c-0.86-0.76-0.81-2.6,0.15-5.46c0.01-0.02,0-0.05-0.03-0.06 c-0.02-0.01-0.05,0-0.06,0.03c-0.97,2.9-1.01,4.77-0.12,5.56c0.44,0.39,0.97,0.42,1.58,0.46c0.61,0.04,1.3,0.07,2.04,0.5 c1.01,0.58,1.73,1.68,2.15,3.27C164.6,70.06,164.62,70.07,164.64,70.07z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M159.84,56.51c0,0,0.01,0,0.01,0c0.02-0.01,0.04-0.03,0.03-0.06c-0.33-0.99-1.3-0.85-2.31-0.69 c-0.64,0.1-1.31,0.2-1.88,0.03c-0.42-0.13-0.67-0.32-0.74-0.58c-0.12-0.44,0.31-0.93,0.31-0.93c0.02-0.02,0.01-0.05,0-0.06 c-0.02-0.02-0.05-0.01-0.06,0c-0.02,0.02-0.47,0.53-0.33,1.01c0.08,0.29,0.35,0.5,0.8,0.64c0.58,0.17,1.26,0.07,1.92-0.03 c1.02-0.16,1.91-0.29,2.22,0.63C159.8,56.5,159.82,56.51,159.84,56.51z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 779.1342,
    y1: 80.9598,
    x2: 785.4755,
    y2: 80.9598,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M13.65,77.69c-0.65,0.69-1.61,1.29-2.28,1.67c1.01,1.24,2.37,2.49,4.17,3.71l0.52,1.16l1.65-1.98 C17.71,82.25,14.74,80.77,13.65,77.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 785.5103,
    y1: 113.5848,
    x2: 790.2654,
    y2: 113.5848,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M22.5,115.28c0-0.04,0-0.07-0.01-0.11c-0.54-2.12-3.19-3.45-3.19-3.45l-1.05,0.08 c-0.61,1.87-0.53,3.02-0.43,3.53c0,0.01,0.01,0.03,0.01,0.04C18.69,115.46,20.48,115.51,22.5,115.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 797.4143,
    y1: 107.9752,
    x2: 780.1154,
    y2: 121.5584,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M17.82,115.38c0.05,0.17,0.17,0.3,0.33,0.34c1.24,0.26,3.2,0.05,4.03-0.06c0.18-0.02,0.31-0.19,0.32-0.38 C20.48,115.51,18.69,115.46,17.82,115.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 786.8326,
    y1: 108.1714,
    x2: 785.9244,
    y2: 116.0983,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M17.82,110.24l0.45,2.15c0.03,0.16,0.15,0.28,0.3,0.29c0.18,0.02,0.43,0.03,0.69-0.01 c0.23-0.03,0.39-0.27,0.35-0.52l-0.31-1.91H17.82z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 800.4874,
    y1: 111.8889,
    x2: 783.1885,
    y2: 125.472,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M27.06,115.36c-1.16-0.03-1.77-0.17-2.08-0.3c0,0.12,0,0.23,0,0.36c0,0.13,0.1,0.23,0.22,0.23l6.39-0.04 c0.2,0,0.32-0.24,0.23-0.42C30.99,115.25,28.86,115.41,27.06,115.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 792.751,
    y1: 113.7112,
    x2: 799.5958,
    y2: 113.7112,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M31.83,115.18c-0.01-0.02-0.01-0.03-0.03-0.05c-0.56-0.79-2-2.36-4.84-3.04l-1.36-0.04 c0,0-0.61,1.05-0.62,3.01c0.31,0.13,0.91,0.26,2.08,0.3C28.86,115.41,30.99,115.25,31.83,115.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 794.2314,
    y1: 109.0191,
    x2: 793.3231,
    y2: 116.9461,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M25.35,109.99c0.02,0.1,0.2,1.64,0.27,2.24c0.02,0.14,0.12,0.25,0.25,0.27c0.23,0.03,0.61,0.05,0.94-0.01 c0.18-0.04,0.31-0.21,0.31-0.4v-2.42L25.35,109.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 805.0235,
    y1: 72.7706,
    x2: 775.973,
    y2: 117.8491,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D4495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#374F9E"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M24.26,81.83c0,0,3.28,12.48,3.23,28.19c0,0.29-0.2,0.53-0.48,0.59c-0.41,0.09-1.02,0.19-1.52,0.18 c-0.27-0.01-0.49-0.21-0.54-0.47c-0.46-2.7-3.1-17.92-4.61-20.39c0,0-0.99,13.55-0.67,20.58c0.01,0.17-0.12,0.33-0.29,0.35 c-0.26,0.03-0.69,0.05-1.22,0c-0.2-0.02-0.37-0.18-0.4-0.38c-0.33-2.29-2.22-15.89-2.14-25.69c0-0.55,1.46-2.96,1.46-2.96H24.26z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.4307,
    y1: 63.9104,
    x2: 14.7657,
    y2: 109.5885
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M28.82,66.73c-0.53-0.67-1-1.38-1.39-2.12c-0.55-1.03-0.04,0.67-0.19-0.5c-4.09-2.95-10.24-1.46-12.62-1.16 c-0.78,0.1-1.49,0.48-2.01,1.08c-2.04,2.36-6.51,8.82-1.25,15.33c0.67-0.37,1.63-0.97,2.28-1.67c-0.58-1.64-0.63-3.74,0.59-6.32 c0.04,0.2,0.09,0.41,0.16,0.6c1.68,5.33,1.77,9.77,1.77,10.79c0,0.14,0.08,0.26,0.21,0.32c2.22,0.89,6.48,0.36,7.91,0.15 c0.26-0.04,0.44-0.28,0.4-0.55c-0.7-5.09,2.9-13.46,3.86-15.56C28.61,66.98,28.71,66.84,28.82,66.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.8393,
    y1: 57.4964,
    x2: 785.3712,
    y2: 72.4833,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M18.45,58.66l-0.43,4.36c0,0,2.45,0.74,4.24-0.52l-1.25-3.96L18.45,58.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: -1326.4753,
    y1: -955.5359,
    x2: -1332.6281,
    y2: -947.3963,
    gradientTransform: "matrix(0.6854 -0.7281 0.7281 0.6854 1625.3878 -256.2873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M21.3,53.69c0.06,0.06,2.49,4.83,2.49,4.83l-2.76,1.33l-2.98-4.19C18.05,55.67,20.31,52.76,21.3,53.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: -1331.1743,
    y1: -953.5812,
    x2: -1323.8247,
    y2: -953.5812,
    gradientTransform: "matrix(0.6854 -0.7281 0.7281 0.6854 1625.3878 -256.2873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M19.27,55.79c-0.05,0.13-0.04,0.27,0.03,0.39l1.38,2.29c0.02,0.03,0.05,0.07,0.08,0.09 c0.16,0.15,0.72,0.6,1.16-0.01c0.37-0.51,0.72-0.98,1.09-1.18c0.22-0.11,0.48-0.02,0.59,0.2c0.23,0.45,0.67,1.36,0.94,2.23 c0.07,0.22-0.04,0.45-0.25,0.54c-0.56,0.23-1.66,0.64-2.64,0.77c-0.16,0.02-0.32-0.05-0.42-0.18c-0.42-0.58-1.61-2.19-2.01-2.59 c-0.38-0.38-1.07-0.23-1.38-0.14c-0.12,0.03-0.25,0.02-0.35-0.05c-0.32-0.19-0.87-0.67-0.37-1.48c0.13-0.2,0.06-0.47-0.14-0.6 c-0.35-0.23-0.74-0.67-0.37-1.38c0.37-0.72,1.03-0.78,1.49-0.73c0.2,0.02,0.4-0.08,0.48-0.27c0.03-0.08,0.1-0.15,0.23-0.18 c0.24-0.05,0.39-0.26,0.35-0.5c-0.08-0.41-0.02-0.93,0.63-1.29c1.19-0.65,2.23,0.41,2.5,1.31c0.27,0.9-1.07,1.54-1.9,1.64 C19.75,54.77,19.41,55.44,19.27,55.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -1335.4866,
    y1: -949.09,
    x2: -1330.5516,
    y2: -954.1532,
    gradientTransform: "matrix(0.6854 -0.7281 0.7281 0.6854 1625.3878 -256.2873)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M19.73,59.18c0,0-0.53-1.55-1.21-1.49c-0.68,0.06-1.21,0.73-0.37,1.49 C19.19,60.13,19.73,59.18,19.73,59.18z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 785.9186,
    y1: 60.32,
    x2: 778.7395,
    y2: 73.5097,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M14.02,70.98c-0.89-2.44-0.57-5.39-0.57-5.42l0.25,0.03c0,0.03-0.32,2.92,0.55,5.31L14.02,70.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.7313,
    y1: 84.8746,
    x2: 786.2953,
    y2: 89.2098,
    gradientTransform: "matrix(1 0 0 1 -767.7686 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M20.21,89.62c-0.06,0-0.11-0.04-0.12-0.09c-0.27-1.05-2.31-2.21-2.33-2.22c-0.06-0.03-0.08-0.11-0.05-0.17 c0.03-0.06,0.11-0.08,0.17-0.05c0.09,0.05,2.15,1.22,2.45,2.37c0.02,0.07-0.02,0.13-0.09,0.15 C20.23,89.62,20.22,89.62,20.21,89.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.0598,
    y1: 64.9245,
    x2: 25.0663,
    y2: 113.8196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M37.12,68.1c-4.62,0.69-7.63-2.22-9.88-3.99c-2.96-2.34-5.27-1.2-5.27-1.2l3.16,6.03 c4.72,4.45,9.56,3.46,12.61,2.02C37.79,69.79,37.47,68.82,37.12,68.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.308,
    y1: 57.1302,
    x2: 27.0855,
    y2: 84.2826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M43.61,65.34l-1.53,0.82c-1.84,1.12-3.48,1.71-4.96,1.93c0.36,0.72,0.67,1.7,0.62,2.86 c1.94-0.92,3.16-2.02,3.16-2.02C44.37,66.87,43.61,65.34,43.61,65.34z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1483,
    y1: 59.3501,
    x2: 29.9257,
    y2: 86.5025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M48.13,67.5c-0.1-0.33-0.34-0.59-0.66-0.72l-3.11-1.25c0,0-0.05-0.4,0.66-0.67 c0.7-0.27,0.54-1.06,0.54-1.06s-0.96,0.44-2.37,1.13c-0.81,0.4-1.26,1.1-1.5,1.63l0.8,1.05c1.92,0.58,3.86,0.69,5.81,0.46 L48.13,67.5z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.8,53.58c-0.01,0-0.01,0-0.02,0c-0.04-0.01-0.06-0.05-0.05-0.08c0.01-0.04,0.2-0.95-0.84-1.43 c-0.03-0.02-0.05-0.06-0.03-0.09c0.02-0.03,0.06-0.05,0.09-0.03c1.14,0.52,0.92,1.57,0.91,1.59 C21.86,53.56,21.83,53.58,21.8,53.58z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 936.9557,
    y1: -3756.7532,
    x2: 940.4943,
    y2: -3756.7532,
    gradientTransform: "matrix(-0.4933 0.8699 -0.8699 -0.4933 -2772.3882 -2563.2825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_48_)"
    },
    d: "M33.83,105.37c-0.21-0.19-0.54-0.46-0.85-0.63 c-0.08-0.04-0.17-0.02-0.23,0.05c-0.32,0.41-1.38,1.84-1.62,2.82c-0.02,0.08,0.02,0.16,0.1,0.2c0.27,0.14,1,0.3,2.03-1.14 l0.62-0.88C33.98,105.67,33.96,105.48,33.83,105.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.357,
    y1: 107.4553,
    x2: 36.7305,
    y2: 98.3345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_49_)"
    },
    d: "M40.11,102.16c0,0-0.35,4.68-2.25,6.23 c-1.67,1.36-4.27-1.12-4.89-1.76c-0.09-0.09-0.13-0.23-0.11-0.35c0.06-0.31,0.21-0.55,0.47-0.7c0.18-0.11,0.42-0.08,0.57,0.06 c0.52,0.48,1.87,1.64,2.56,1.36c0.87-0.35,1.39-4.85,1.39-4.85H40.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: -90.7034,
    y1: -4494.439,
    x2: -89.4929,
    y2: -4505.4858,
    gradientTransform: "matrix(-0.8899 0.4561 -0.4561 -0.8899 -2098.9553 -3881.0271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_50_)"
    },
    d: "M35.61,87.96c0,0-2.6-1.21-4.03-7.86l0.71-0.36 c0,0,2.76,5.43,4.18,6.66C37.9,87.64,35.61,87.96,35.61,87.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: -89.884,
    y1: -4494.2056,
    x2: -88.6068,
    y2: -4505.8604,
    gradientTransform: "matrix(-0.8899 0.4561 -0.4561 -0.8899 -2098.9553 -3881.0271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_51_)"
    },
    d: "M32.14,80.54l-0.55-0.44c0,0-0.75-0.73-1.01-1.35 c-0.26-0.62,0.51-1.18,0.8-1.31c0.29-0.13,0.45,0.15,0.39,0.77c0,0,0.66,0.77,0.57,1.9L32.14,80.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 1138.1221,
    y1: -3863.927,
    x2: 1139.3993,
    y2: -3875.5818,
    gradientTransform: "matrix(0.8899 0.4561 0.4561 -0.8899 800.2486 -3881.0271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_52_)"
    },
    d: "M47.22,87.96c0,0,2.94-4.58,3.47-8.38l-0.71-0.36 c0,0-2.94,6.15-4.36,7.39C44.2,87.85,47.22,87.96,47.22,87.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 1138.8804,
    y1: -3863.844,
    x2: 1140.1576,
    y2: -3875.4985,
    gradientTransform: "matrix(0.8899 0.4561 0.4561 -0.8899 800.2486 -3881.0271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_53_)"
    },
    d: "M50.14,80.02l0.55-0.44c0,0,0.75-0.73,1.01-1.35 c0.26-0.62-0.51-1.18-0.8-1.31c-0.29-0.13-0.45,0.15-0.39,0.77c0,0-0.66,0.77-0.57,1.9L50.14,80.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.3566,
    y1: 117.2554,
    x2: 37.8955,
    y2: 117.2554,
    gradientTransform: "matrix(1 -4.700000e-03 4.700000e-03 1 5.9179 -2.0717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_54_)"
    },
    d: "M41.02,114.19c0,0-0.21,0.77-0.19,1.33 c0,0.09,0.07,0.16,0.16,0.18c0.52,0.07,2.28,0.28,3.25,0c0.08-0.02,0.13-0.1,0.13-0.18c-0.01-0.3-0.22-1.02-2-1.2L41.02,114.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.2218,
    y1: 61.8475,
    x2: 194.8911,
    y2: 45.5038,
    gradientTransform: "matrix(0.9977 0.0685 -0.0685 0.9977 -147.746 37.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_55_)"
    },
    d: "M44.07,102.47c0.22,0.14-1.43,11.69-1.83,11.78 c0,0-0.46,0.42-1.16-0.06c0.41-3.76,0.65-7.58,0.43-11.49L44.07,102.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.1346,
    y1: 49.477,
    x2: 196.3057,
    y2: 49.477,
    gradientTransform: "matrix(0.9977 0.0685 -0.0685 0.9977 -147.746 37.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_56_)"
    },
    d: "M38.3,95.46c0,0,5.36,0.25,6.64,0.69 c0,0-0.16,4.36-0.68,7.04c-0.02,0.1-0.1,0.19-0.2,0.21c-0.34,0.08-1.21,0.19-2.58-0.19c-0.12-0.03-0.2-0.15-0.19-0.28l0.14-1.74 c0.01-0.12-0.08-0.22-0.2-0.23l-0.14-0.02c-0.12-0.01-0.23,0.09-0.23,0.21l-0.27,1.76c0,0.11-0.07,0.21-0.18,0.25 c-0.4,0.14-1.45,0.39-2.84-0.03c-0.11-0.03-0.19-0.14-0.19-0.25C37.36,100.75,37.75,98.2,38.3,95.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.0596,
    y1: 44.8496,
    x2: 191.0471,
    y2: 47.5599,
    gradientTransform: "matrix(0.9977 0.0685 -0.0685 0.9977 -147.746 37.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_57_)"
    },
    d: "M40.31,95.84c0,0-0.68,1.89-2.31,2.02l0.36-2.15 C38.36,95.7,39.63,95.69,40.31,95.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: -798.5958,
    y1: 166.803,
    x2: -799.6394,
    y2: 158.4547,
    gradientTransform: "matrix(0.9402 -0.3405 0.3405 0.9402 741.0815 -344.3699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_58_)"
    },
    d: "M45.41,81.94c0,0-0.21-0.58,0.32-0.69 c0.53-0.1,0.02,1.44,0.02,1.44L45.41,81.94z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.9849,
    y1: 85.893,
    x2: 39.6086,
    y2: 100.6374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CC9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C519F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_59_)"
    },
    d: "M35.78,85.54c0,0,2.42,1.56,5.37,1.39 c2.46-0.14,3.95-0.77,4.78-1.48c0.3-0.25,0.72-0.29,1.05-0.08c0.36,0.23,0.84,0.59,1.34,1.11c0.13,0.13,0.15,0.33,0.06,0.49 c-0.72,1.16-1.48,1.96-2.29,2.43c-0.27,0.3-0.42,0.7-0.41,1.1l0.15,5.68c0,0.16-0.11,0.29-0.26,0.32 c-1.08,0.2-5.16,0.92-7.7,0.47v-6.12c0-0.46-0.25-0.87-0.65-1.09c-0.53-0.3-1.33-0.88-2.12-1.97L35.78,85.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.7346,
    y1: 91.5868,
    x2: 42.3433,
    y2: 81.8041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_60_)"
    },
    d: "M39.99,84.23l-0.27,2.92c0,0,1.54,0.9,2.87,0.11 l-0.24-2.55L39.99,84.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: -975.9659,
    y1: 94.0617,
    x2: -979.5279,
    y2: 87.2551,
    gradientTransform: "matrix(0.9011 -0.4336 0.4336 0.9011 882.0199 -425.3417)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_61_)"
    },
    d: "M45.69,82.15c0,0,0.68-1.16-0.19-1.77 c0,0,0.46-1.02-0.41-1.76c0,0-1.39-3.26-4.31-0.97c0,0-2.51-0.75-3.32,2.38c0,0-0.84,0.47-0.45,1.64c0,0-0.09,4.33,3.7,2.87 L45.69,82.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: -801.8871,
    y1: 167.3178,
    x2: -802.9473,
    y2: 158.8356,
    gradientTransform: "matrix(0.9402 -0.3405 0.3405 0.9402 741.0815 -344.3699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_62_)"
    },
    d: "M44.44,79.73c0,0,3.22,4.85-0.11,6.33 c-3.14,1.4-4.46-1.82-4.46-1.82s-1.38-1.43-0.92-2.53C39.42,80.62,43.65,79.13,44.44,79.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -801.5339,
    y1: 163.7171,
    x2: -804.8882,
    y2: 157.3073,
    gradientTransform: "matrix(0.9402 -0.3405 0.3405 0.9402 741.0815 -344.3699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2A3780"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#201D3F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_63_)"
    },
    d: "M39.56,83.48c0,0,3.15-1,2.88-2.86 c0,0,0.55,0.05,0.71-0.59c0,0,1.55,1.39,1.95,0.42c0,0-0.27-2.41-2.16-1.63c-1.89,0.78-3.61,1.57-4.12,2.13 C38.32,81.51,37.9,82.86,39.56,83.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: -805.0203,
    y1: 167.606,
    x2: -806.0638,
    y2: 159.2577,
    gradientTransform: "matrix(0.9402 -0.3405 0.3405 0.9402 741.0815 -344.3699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_64_)"
    },
    d: "M40.28,84.68l-0.56-1.54c0,0-1.08-0.5-0.94,0.34 C38.93,84.32,39.9,84.78,40.28,84.68z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.1,79.98c-0.04,0-0.07-0.03-0.07-0.07c0-0.1,0.01-0.19,0.02-0.29c0.04-0.41,0.07-0.73-0.74-1.11 c-0.02-0.01-0.03-0.02-0.03-0.03c-0.59-1.34-1.86-1.02-1.91-1c-0.04,0.01-0.07-0.01-0.08-0.05c-0.01-0.04,0.01-0.07,0.05-0.08 c0.01,0,1.41-0.36,2.06,1.06c0.87,0.41,0.84,0.81,0.8,1.23c-0.01,0.09-0.02,0.18-0.02,0.27C45.17,79.95,45.14,79.98,45.1,79.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: -3587.8643,
    y1: -240.3826,
    x2: -3584.0542,
    y2: -231.7138,
    gradientTransform: "matrix(0.9776 -0.2106 0.2106 0.9776 3695.0864 -432.339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M135.36,85.48c0,0,2.33,6.29,5.89,5.52c0,0,0.37,2.14-0.23,2.39c0,0-5.33,0.15-5.86-7.16L135.36,85.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: -3587.7639,
    y1: -239.7253,
    x2: -3583.6155,
    y2: -230.2867,
    gradientTransform: "matrix(0.9776 -0.2106 0.2106 0.9776 3695.0864 -432.339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M135.46,86.96c-0.01,0.11,0.4,0.18,0.52-0.28c-0.04-0.2-0.1-1.09-0.25-1.22 c-0.82-0.73-2.29-1.55-2.29-1.55c-0.16,0.25,0.05,0.42,0.05,0.42l0.73,0.5c-0.08,0.25-0.19,0.48-0.2,0.77 c-0.01,0.22,0.07,0.43,0.22,0.6c0.15,0.17,0.34,0.38,0.52,0.55C135.09,87.03,135.46,86.96,135.46,86.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: -349.7667,
    y1: 85.8295,
    x2: -348.5916,
    y2: 85.8295,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M135.03,86.61c-0.14-0.35-0.39-0.91-0.51-1.02c-0.1-0.1-0.14-0.19-0.14-0.29c0-0.08,0.05-0.15,0.12-0.21 l0.05-0.04l0.72,0.39l0.28,0.44l-0.16,0.1l-0.26-0.4l-0.56-0.3c-0.01,0.02-0.01,0.03-0.01,0.04c0,0.04,0.03,0.09,0.08,0.15 c0.17,0.18,0.51,0.99,0.54,1.08L135.03,86.61z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: -352.1407,
    y1: 80.5527,
    x2: -356.5052,
    y2: 84.4037,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_68_)"
    },
    d: "M141.21,82.85c0,0,1.13-1.02-0.32-2.12 c-1.36-1.04-2.36,0.35-1.91,1.25c0.03,0.06,0,0.14-0.07,0.16c-0.12,0.03-0.22,0.14-0.03,0.56c0.02,0.04,0.01,0.08-0.01,0.11 c-0.17,0.22-0.72,1.12,0.96,1.26c0.03,0,0.06-0.01,0.08-0.03L141.21,82.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: -1041.0474,
    y1: 117.7169,
    x2: -1037.5049,
    y2: 117.7169,
    gradientTransform: "matrix(-0.9842 -0.1769 -0.1769 0.9842 -853.1446 -215.1858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_69_)"
    },
    d: "M147.13,84.35c0,0,0.11-1.3,0.8-1.72 s2.05-0.78,2.61,0.63c0.27,0.67,0.18,0.99,0.01,1.15c-0.15,0.14-0.17,0.35-0.07,0.53c0.11,0.2,0.13,0.46-0.22,0.69 c-0.1,0.07-0.17,0.17-0.19,0.28c-0.09,0.47-0.57,1.6-3.15,0.37L147.13,84.35z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: -1031.0969,
    y1: 114.4802,
    x2: -1034.2775,
    y2: 119.3099,
    gradientTransform: "matrix(-0.9842 -0.1769 -0.1769 0.9842 -853.1446 -215.1858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_70_)"
    },
    d: "M144.15,82.01c0.51-0.22,1.58-0.44,2.42,1.02 c0.06,0.1,0.14,0.19,0.25,0.24c0.5,0.27,1.94,1.27,0.63,3.07c-0.06,0.08-0.1,0.18-0.11,0.28c-0.04,0.31-0.19,0.98-0.63,1.15 c-0.13,0.05-0.24,0.14-0.31,0.26c-0.29,0.48-1.13,1.5-2.54,0.44c-0.07-0.05-0.15-0.09-0.24-0.11l-1.94-0.43 c-0.1-0.02-0.21-0.02-0.31,0.01c-0.24,0.07-0.72,0.13-0.9-0.43c-0.04-0.11-0.1-0.22-0.19-0.29c-0.33-0.28-1.02-1.03-0.49-2.08 c0.06-0.12,0.08-0.25,0.06-0.38c-0.06-0.39-0.09-1.27,0.72-1.65c0.12-0.06,0.23-0.15,0.29-0.27c0.27-0.53,1.16-1.87,2.73-0.88 C143.74,82.07,143.96,82.09,144.15,82.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: -355.9995,
    y1: 113.6712,
    x2: -352.6069,
    y2: 113.6712,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_71_)"
    },
    d: "M141.51,112.89l0.28,0.33l-0.19,0.71 c-0.05,0.19-0.2,0.33-0.39,0.36c-0.63,0.12-2.06,0.32-2.8,0.01c0,0-0.23-1.54,2.31-1.08L141.51,112.89z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: -360.2937,
    y1: 114.7712,
    x2: -358.4067,
    y2: 114.7712,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_72_)"
    },
    d: "M145.94,113.7l0.15,0.37l-0.06,1.33 c-0.01,0.19-0.16,0.34-0.36,0.38c-0.28,0.04-0.68,0.09-1.06,0.06c-0.3-0.02-0.48-0.3-0.37-0.55l0.45-0.96 c0.07-0.14,0.19-0.25,0.34-0.31L145.94,113.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: -358.1249,
    y1: 93.3552,
    x2: -357.852,
    y2: 90.5806,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_73_)"
    },
    d: "M144.65,87.76l0.29,2.86c0,0-1.56,0.53-2.58-0.07 l0.28-2.87L144.65,87.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: -361.3504,
    y1: 108.7057,
    x2: -358.5503,
    y2: 108.7057,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_74_)"
    },
    d: "M147.14,103.44c0,0-0.74,8.23-1.23,10.75 c0,0-0.36,0.27-0.91-0.08l-0.66-10.99L147.14,103.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: -358.0683,
    y1: 108.4313,
    x2: -354.779,
    y2: 108.4313,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_75_)"
    },
    d: "M143.86,103.93l-2.02,9.22c0,0-0.55,0.57-1.27,0 l0.35-9.69L143.86,103.93z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: -368.6441,
    y1: 104.5833,
    x2: -359.4833,
    y2: 91.9966,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_76_)"
    },
    d: "M146.42,90.84l0.51,0.06 c0.98,1.05,2.78,8.27,3.43,9.81l2.64-0.43c0.1-0.02,0.19,0.08,0.15,0.18c-0.12,0.29-0.56,1.11-2.27,1.11 c-0.8,0,0.45,0.62-0.03,0.83c0,0-1.05-0.38-1.05-1.04c0,0-3.01-6.87-3.63-7.59C145.53,93.04,146.42,90.84,146.42,90.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: -356.304,
    y1: 89.8652,
    x2: -362.8476,
    y2: 100.9513,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_77_)"
    },
    d: "M146.93,90.9c0,0-2.68-0.99-6.03,0.03 c0,0-0.38,2.53-0.18,3.74l5.77,0.21L146.93,90.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: -613.2955,
    y1: 88.6833,
    x2: -614.6734,
    y2: 76.7291,
    gradientTransform: "matrix(-0.9949 0.1004 0.1004 0.9949 -475.1766 79.4228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_78_)"
    },
    d: "M140.8,95.47c0,0-1.84,5.92-2.12,9.86 c-0.01,0.2,0.14,0.38,0.34,0.39c0.38,0.03,1.06,0.12,1.98,0.43c1.49,0.5,2.72,0.33,3.84,0.01c0.87-0.25,3.06-0.47,3.96-0.55 c0.21-0.02,0.37-0.22,0.33-0.43c-0.26-1.46-1.26-6.64-2.77-10.16L140.8,95.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: -356.1787,
    y1: 91.4197,
    x2: -357.2586,
    y2: 93.7657,
    gradientTransform: "matrix(-1 0 0 1 -214.2058 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7EA4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93E66"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_79_)"
    },
    d: "M140.7,94.54l0.1,0.93c0,0,1.77,0.01,5.69-0.12 l0.02-0.67C146.51,94.67,142.17,94.75,140.7,94.54z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: -1048.3285,
    y1: -61.3171,
    x2: -1047.9651,
    y2: -66.7235,
    gradientTransform: "matrix(-0.9852 -0.1732 -0.1896 1.0333 -901.6934 -28.6271)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_80_)"
    },
    d: "M140.71,84.99c-0.45,1.72-0.32,3.7,1.71,4.14 c1.4,0.31,2.87-1.12,3.32-2.84c0.45-1.72-0.32-3.03-1.71-3.39C142.64,82.54,141.16,83.27,140.71,84.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: -1031.4768,
    y1: 123.6487,
    x2: -1031.1129,
    y2: 118.2358,
    gradientTransform: "matrix(-0.9842 -0.1769 -0.1769 0.9842 -853.1446 -215.1858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_81_)"
    },
    d: "M140.86,85.52c0,0-0.07-1.04-0.59-0.72 c-0.52,0.32,0.2,1.57,0.52,1.64C141.12,86.51,140.86,85.52,140.86,85.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: -1036.5829,
    y1: 123.3053,
    x2: -1036.219,
    y2: 117.8924,
    gradientTransform: "matrix(-0.9842 -0.1769 -0.1769 0.9842 -853.1446 -215.1858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF7A62"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_82_)"
    },
    d: "M145.3,86.72c0,0,0.16-0.79,0.72-0.43 c0.56,0.37-0.51,1.66-1.17,1.38L145.3,86.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: -1031.1207,
    y1: 114.4645,
    x2: -1034.3013,
    y2: 119.2943,
    gradientTransform: "matrix(-0.9842 -0.1769 -0.1769 0.9842 -853.1446 -215.1858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC246E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C266C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_83_)"
    },
    d: "M146.14,86.09c0,0-1.61,1.74-2.45-1.87 c0,0-0.83,1.08-1.22,0.12c0,0-1.66,0.57-1.85-0.13c-0.18-0.7,2.25-2.59,4.2-1.23C146.78,84.34,146.14,86.09,146.14,86.09z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.13,84.24c0,0-0.01,0-0.01,0c-0.04-0.01-0.06-0.04-0.06-0.08c0.09-0.51,0.25-0.63,0.71-1 c0.09-0.07,0.18-0.14,0.29-0.23c0.15-0.65,1.09-0.78,1.13-0.78c0.04,0,0.07,0.02,0.08,0.06c0,0.04-0.02,0.07-0.06,0.08 c-0.01,0-0.9,0.12-1.02,0.7c0,0.02-0.01,0.03-0.02,0.04c-0.12,0.09-0.22,0.17-0.31,0.24c-0.46,0.36-0.58,0.45-0.66,0.91 C140.19,84.21,140.16,84.24,140.13,84.24z"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.9,52.93c-0.11,0-0.21-0.07-0.26-0.17c-0.11-0.28-0.23-0.56-0.35-0.84c-0.06-0.14,0-0.3,0.14-0.36 c0.14-0.06,0.3,0,0.36,0.14c0.13,0.28,0.25,0.57,0.36,0.86c0.06,0.14-0.01,0.3-0.15,0.36C60.97,52.92,60.94,52.93,60.9,52.93z  M60.15,51.25c-0.1,0-0.2-0.06-0.25-0.15c-0.13-0.27-0.28-0.54-0.42-0.8c-0.07-0.13-0.02-0.3,0.11-0.38 c0.13-0.07,0.3-0.02,0.38,0.11c0.15,0.27,0.29,0.55,0.43,0.82c0.07,0.14,0.01,0.3-0.12,0.37C60.24,51.24,60.19,51.25,60.15,51.25z  M59.26,49.64c-0.09,0-0.18-0.05-0.24-0.13c-0.16-0.26-0.32-0.52-0.49-0.77c-0.08-0.13-0.05-0.3,0.08-0.38 c0.13-0.08,0.3-0.05,0.38,0.08c0.17,0.26,0.34,0.52,0.5,0.79c0.08,0.13,0.04,0.3-0.09,0.38C59.36,49.63,59.31,49.64,59.26,49.64z  M58.25,48.11c-0.09,0-0.17-0.04-0.22-0.11c-0.18-0.24-0.36-0.49-0.55-0.73c-0.09-0.12-0.07-0.29,0.05-0.39 c0.12-0.09,0.29-0.07,0.39,0.05c0.19,0.24,0.38,0.49,0.56,0.74c0.09,0.12,0.06,0.3-0.06,0.39C58.36,48.09,58.3,48.11,58.25,48.11z  M57.11,46.66c-0.08,0-0.16-0.03-0.21-0.1c-0.2-0.23-0.4-0.46-0.6-0.68c-0.1-0.11-0.1-0.29,0.02-0.39c0.11-0.1,0.29-0.1,0.39,0.02 c0.21,0.23,0.42,0.46,0.62,0.7c0.1,0.12,0.09,0.29-0.03,0.39C57.24,46.64,57.17,46.66,57.11,46.66z M55.86,45.31 c-0.07,0-0.14-0.03-0.2-0.08c-0.21-0.21-0.43-0.43-0.65-0.63c-0.11-0.1-0.12-0.28-0.01-0.39c0.1-0.11,0.28-0.12,0.39-0.01 c0.23,0.21,0.45,0.43,0.67,0.65c0.11,0.11,0.11,0.28,0,0.39C56,45.28,55.93,45.31,55.86,45.31z M54.52,44.05 c-0.06,0-0.13-0.02-0.18-0.07c-0.23-0.2-0.46-0.4-0.7-0.59c-0.12-0.1-0.14-0.27-0.04-0.39c0.1-0.12,0.27-0.14,0.39-0.04 c0.24,0.2,0.48,0.4,0.71,0.6c0.11,0.1,0.13,0.27,0.03,0.39C54.67,44.01,54.6,44.05,54.52,44.05z M53.09,42.88 c-0.06,0-0.12-0.02-0.17-0.06c-0.24-0.18-0.49-0.37-0.73-0.54c-0.12-0.09-0.15-0.26-0.06-0.39c0.09-0.12,0.26-0.15,0.39-0.06 c0.25,0.18,0.5,0.37,0.75,0.55c0.12,0.09,0.14,0.27,0.05,0.39C53.26,42.84,53.18,42.88,53.09,42.88z M51.6,41.81 c-0.05,0-0.11-0.02-0.15-0.05c-0.25-0.17-0.51-0.33-0.77-0.5c-0.13-0.08-0.17-0.25-0.09-0.38c0.08-0.13,0.25-0.17,0.38-0.09 c0.26,0.17,0.53,0.34,0.78,0.51c0.13,0.09,0.16,0.26,0.08,0.38C51.77,41.77,51.69,41.81,51.6,41.81z M50.04,40.83 c-0.05,0-0.1-0.01-0.14-0.04c-0.26-0.15-0.53-0.31-0.79-0.45c-0.13-0.07-0.18-0.24-0.11-0.38c0.07-0.13,0.24-0.18,0.38-0.11 c0.27,0.15,0.54,0.31,0.81,0.46c0.13,0.08,0.17,0.25,0.1,0.38C50.22,40.78,50.13,40.83,50.04,40.83z M48.43,39.93 c-0.04,0-0.09-0.01-0.13-0.03c-0.27-0.14-0.54-0.28-0.82-0.41c-0.14-0.07-0.19-0.23-0.13-0.37c0.07-0.14,0.23-0.19,0.37-0.13 c0.28,0.14,0.55,0.27,0.83,0.42c0.14,0.07,0.19,0.24,0.12,0.37C48.62,39.88,48.53,39.93,48.43,39.93z M46.77,39.12 c-0.04,0-0.08-0.01-0.12-0.03c-0.28-0.13-0.56-0.25-0.84-0.37c-0.14-0.06-0.2-0.22-0.14-0.36c0.06-0.14,0.22-0.2,0.36-0.14 c0.28,0.12,0.56,0.25,0.85,0.38c0.14,0.06,0.2,0.23,0.14,0.37C46.98,39.06,46.88,39.12,46.77,39.12z M45.08,38.39 c-0.03,0-0.07-0.01-0.1-0.02c-0.29-0.12-0.57-0.23-0.85-0.33c-0.14-0.05-0.21-0.21-0.16-0.36c0.05-0.14,0.21-0.21,0.36-0.16 c0.28,0.11,0.57,0.22,0.86,0.34c0.14,0.06,0.21,0.22,0.15,0.36C45.29,38.32,45.19,38.39,45.08,38.39z M43.36,37.73 c-0.03,0-0.06-0.01-0.09-0.02c-0.29-0.1-0.58-0.2-0.87-0.3c-0.14-0.05-0.22-0.2-0.18-0.35c0.05-0.14,0.2-0.22,0.35-0.18 c0.29,0.1,0.58,0.2,0.88,0.3c0.14,0.05,0.22,0.21,0.17,0.35C43.58,37.66,43.47,37.73,43.36,37.73z M41.61,37.15 c-0.03,0-0.05,0-0.08-0.01c-0.3-0.09-0.59-0.18-0.88-0.26c-0.15-0.04-0.23-0.2-0.19-0.34c0.04-0.15,0.19-0.23,0.34-0.19 c0.29,0.08,0.59,0.17,0.89,0.26c0.15,0.05,0.23,0.2,0.18,0.35C41.84,37.08,41.73,37.15,41.61,37.15z M39.83,36.64 c-0.02,0-0.05,0-0.07-0.01c-0.31-0.08-0.6-0.16-0.89-0.23c-0.15-0.04-0.24-0.19-0.2-0.33c0.04-0.15,0.19-0.24,0.33-0.2 c0.29,0.07,0.59,0.15,0.9,0.23c0.15,0.04,0.24,0.19,0.2,0.34C40.07,36.56,39.96,36.64,39.83,36.64z M38.04,36.21 c-0.02,0-0.04,0-0.06-0.01c-0.32-0.07-0.62-0.13-0.9-0.19c-0.15-0.03-0.25-0.17-0.22-0.32c0.03-0.15,0.17-0.25,0.32-0.22 c0.28,0.05,0.58,0.12,0.91,0.19c0.15,0.03,0.24,0.18,0.21,0.33C38.28,36.12,38.17,36.21,38.04,36.21z M36.23,35.86 c-0.02,0-0.03,0-0.05,0c-0.57-0.1-0.9-0.13-0.9-0.14c-0.15-0.02-0.26-0.15-0.24-0.31c0.02-0.15,0.15-0.26,0.31-0.24 c0.01,0,0.34,0.04,0.93,0.14c0.15,0.03,0.25,0.17,0.23,0.32C36.48,35.76,36.36,35.86,36.23,35.86z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.95,50.97c-0.15,0-0.27-0.12-0.28-0.27c-0.01-0.3-0.02-0.61-0.04-0.91c-0.01-0.15,0.11-0.28,0.26-0.29 c0.15-0.01,0.28,0.11,0.29,0.26c0.02,0.31,0.03,0.62,0.04,0.93C84.23,50.83,84.11,50.96,83.95,50.97 C83.96,50.97,83.95,50.97,83.95,50.97z M83.84,49.13c-0.14,0-0.26-0.11-0.27-0.25c-0.03-0.3-0.06-0.61-0.1-0.91 c-0.02-0.15,0.09-0.29,0.24-0.31c0.15-0.02,0.29,0.09,0.31,0.24c0.04,0.31,0.07,0.62,0.1,0.92c0.01,0.15-0.1,0.29-0.25,0.3 C83.86,49.13,83.85,49.13,83.84,49.13z M83.61,47.3c-0.13,0-0.25-0.1-0.27-0.23c-0.05-0.3-0.1-0.6-0.16-0.9 c-0.03-0.15,0.07-0.29,0.22-0.32c0.15-0.03,0.3,0.07,0.32,0.22c0.06,0.3,0.11,0.61,0.16,0.92c0.02,0.15-0.08,0.29-0.23,0.32 C83.64,47.3,83.62,47.3,83.61,47.3z M83.25,45.5c-0.13,0-0.24-0.09-0.27-0.21c-0.07-0.3-0.14-0.59-0.22-0.88 c-0.04-0.15,0.05-0.3,0.19-0.34c0.15-0.04,0.3,0.05,0.34,0.19c0.08,0.3,0.16,0.6,0.23,0.9c0.03,0.15-0.06,0.3-0.21,0.33 C83.3,45.5,83.28,45.5,83.25,45.5z M82.77,43.72c-0.12,0-0.23-0.08-0.26-0.19c-0.09-0.29-0.19-0.58-0.29-0.86 c-0.05-0.14,0.03-0.3,0.17-0.35c0.14-0.05,0.3,0.03,0.35,0.17c0.1,0.29,0.2,0.59,0.29,0.88c0.05,0.15-0.04,0.3-0.18,0.35 C82.83,43.72,82.8,43.72,82.77,43.72z M82.16,41.99c-0.11,0-0.21-0.07-0.26-0.18c-0.11-0.28-0.23-0.56-0.35-0.84 c-0.06-0.14,0-0.3,0.14-0.36c0.14-0.06,0.3,0,0.36,0.14c0.12,0.28,0.24,0.57,0.36,0.86c0.06,0.14-0.01,0.3-0.16,0.36 C82.23,41.98,82.2,41.99,82.16,41.99z M81.43,40.3c-0.1,0-0.2-0.06-0.25-0.16c-0.13-0.27-0.27-0.55-0.41-0.81 c-0.07-0.13-0.02-0.3,0.12-0.37c0.13-0.07,0.3-0.02,0.37,0.12c0.14,0.27,0.29,0.55,0.42,0.83c0.07,0.14,0.01,0.3-0.13,0.37 C81.51,40.29,81.47,40.3,81.43,40.3z M80.57,38.67c-0.1,0-0.19-0.05-0.24-0.14c-0.15-0.26-0.31-0.52-0.47-0.78 c-0.08-0.13-0.04-0.3,0.09-0.38c0.13-0.08,0.3-0.04,0.38,0.09c0.16,0.26,0.32,0.53,0.48,0.8c0.08,0.13,0.03,0.3-0.1,0.38 C80.66,38.66,80.62,38.67,80.57,38.67z M79.6,37.11c-0.09,0-0.18-0.04-0.23-0.12c-0.17-0.25-0.35-0.5-0.52-0.75 c-0.09-0.12-0.06-0.3,0.06-0.39c0.12-0.09,0.3-0.06,0.39,0.06c0.18,0.25,0.36,0.51,0.53,0.76c0.09,0.13,0.05,0.3-0.07,0.38 C79.7,37.09,79.65,37.11,79.6,37.11z M78.51,35.62c-0.08,0-0.16-0.04-0.22-0.11c-0.19-0.24-0.38-0.48-0.57-0.71 c-0.1-0.12-0.08-0.29,0.03-0.39c0.12-0.1,0.29-0.08,0.39,0.03c0.2,0.24,0.4,0.48,0.59,0.72c0.09,0.12,0.07,0.29-0.05,0.39 C78.63,35.6,78.57,35.62,78.51,35.62z M77.33,34.21c-0.08,0-0.15-0.03-0.21-0.09c-0.2-0.22-0.41-0.45-0.62-0.67 c-0.11-0.11-0.1-0.28,0.01-0.39c0.11-0.11,0.28-0.1,0.39,0.01c0.22,0.22,0.43,0.45,0.64,0.68c0.1,0.11,0.09,0.29-0.02,0.39 C77.46,34.19,77.39,34.21,77.33,34.21z M76.05,32.89c-0.07,0-0.14-0.03-0.19-0.08c-0.22-0.21-0.44-0.42-0.67-0.62 c-0.11-0.1-0.12-0.28-0.02-0.39c0.1-0.11,0.28-0.12,0.39-0.02c0.23,0.21,0.46,0.42,0.68,0.64c0.11,0.11,0.11,0.28,0.01,0.39 C76.19,32.86,76.12,32.89,76.05,32.89z M74.68,31.65c-0.06,0-0.13-0.02-0.18-0.07c-0.23-0.2-0.47-0.39-0.71-0.58 c-0.12-0.09-0.14-0.27-0.05-0.39c0.09-0.12,0.27-0.14,0.39-0.05c0.24,0.19,0.49,0.39,0.72,0.59c0.12,0.1,0.13,0.27,0.03,0.39 C74.83,31.62,74.76,31.65,74.68,31.65z M73.23,30.51c-0.06,0-0.11-0.02-0.16-0.05c-0.25-0.18-0.5-0.36-0.75-0.52 c-0.13-0.09-0.16-0.26-0.08-0.38c0.08-0.13,0.26-0.16,0.38-0.08c0.25,0.17,0.51,0.35,0.76,0.53c0.12,0.09,0.15,0.26,0.06,0.39 C73.4,30.47,73.31,30.51,73.23,30.51z M71.69,29.49c-0.05,0-0.1-0.01-0.14-0.04c-0.49-0.3-0.78-0.45-0.79-0.45 c-0.14-0.07-0.19-0.23-0.12-0.37c0.07-0.14,0.23-0.19,0.37-0.12c0.01,0.01,0.31,0.16,0.83,0.47c0.13,0.08,0.17,0.25,0.09,0.38 C71.88,29.44,71.79,29.49,71.69,29.49z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.64,52.93c-0.03,0-0.07-0.01-0.1-0.02c-0.14-0.06-0.21-0.22-0.15-0.36c0.11-0.29,0.24-0.58,0.36-0.86 c0.06-0.14,0.23-0.2,0.36-0.14c0.14,0.06,0.2,0.23,0.14,0.36c-0.12,0.28-0.24,0.56-0.35,0.84 C122.85,52.86,122.75,52.93,122.64,52.93z M123.39,51.25c-0.04,0-0.08-0.01-0.12-0.03c-0.14-0.07-0.19-0.23-0.12-0.37 c0.14-0.28,0.28-0.55,0.43-0.82c0.07-0.13,0.24-0.18,0.38-0.11s0.18,0.24,0.11,0.38c-0.15,0.26-0.29,0.54-0.42,0.8 C123.59,51.19,123.49,51.25,123.39,51.25z M124.28,49.64c-0.05,0-0.1-0.01-0.14-0.04c-0.13-0.08-0.17-0.25-0.09-0.38 c0.16-0.26,0.33-0.53,0.5-0.79c0.08-0.13,0.26-0.16,0.38-0.08c0.13,0.08,0.16,0.26,0.08,0.38c-0.17,0.25-0.33,0.51-0.49,0.77 C124.46,49.59,124.37,49.64,124.28,49.64z M125.29,48.11c-0.06,0-0.11-0.02-0.16-0.05c-0.12-0.09-0.15-0.26-0.06-0.39 c0.18-0.25,0.37-0.5,0.56-0.74c0.09-0.12,0.27-0.14,0.39-0.05c0.12,0.09,0.14,0.27,0.05,0.39c-0.19,0.24-0.37,0.48-0.55,0.73 C125.46,48.07,125.38,48.11,125.29,48.11z M126.43,46.66c-0.06,0-0.13-0.02-0.18-0.07c-0.12-0.1-0.13-0.27-0.03-0.39 c0.2-0.23,0.41-0.47,0.62-0.7c0.1-0.11,0.28-0.12,0.39-0.02c0.11,0.1,0.12,0.28,0.02,0.39c-0.21,0.22-0.41,0.45-0.6,0.68 C126.59,46.63,126.51,46.66,126.43,46.66z M127.68,45.31c-0.07,0-0.14-0.03-0.19-0.08c-0.11-0.11-0.11-0.28,0-0.39 c0.22-0.22,0.44-0.44,0.67-0.65c0.11-0.1,0.29-0.1,0.39,0.01c0.1,0.11,0.1,0.29-0.01,0.39c-0.22,0.21-0.44,0.42-0.65,0.63 C127.82,45.28,127.75,45.31,127.68,45.31z M129.02,44.05c-0.08,0-0.15-0.03-0.21-0.09c-0.1-0.11-0.09-0.29,0.03-0.39 c0.23-0.2,0.47-0.4,0.71-0.6c0.12-0.1,0.29-0.08,0.39,0.04c0.1,0.12,0.08,0.29-0.04,0.39c-0.24,0.19-0.47,0.39-0.7,0.59 C129.15,44.02,129.09,44.05,129.02,44.05z M130.45,42.88c-0.08,0-0.17-0.04-0.22-0.11c-0.09-0.12-0.07-0.29,0.05-0.39 c0.24-0.19,0.5-0.37,0.75-0.55c0.12-0.09,0.3-0.06,0.39,0.06c0.09,0.12,0.06,0.3-0.06,0.39c-0.25,0.18-0.49,0.36-0.73,0.54 C130.56,42.86,130.51,42.88,130.45,42.88z M131.94,41.81c-0.09,0-0.18-0.04-0.23-0.12c-0.08-0.13-0.05-0.3,0.08-0.38 c0.25-0.17,0.52-0.34,0.78-0.51c0.13-0.08,0.3-0.04,0.38,0.09c0.08,0.13,0.04,0.3-0.09,0.38c-0.26,0.16-0.52,0.33-0.77,0.5 C132.05,41.79,132,41.81,131.94,41.81z M133.5,40.83c-0.09,0-0.19-0.05-0.24-0.14c-0.08-0.13-0.03-0.3,0.1-0.38 c0.26-0.16,0.53-0.31,0.81-0.46c0.13-0.07,0.3-0.03,0.38,0.11c0.07,0.13,0.03,0.3-0.11,0.38c-0.27,0.15-0.53,0.3-0.79,0.45 C133.6,40.82,133.55,40.83,133.5,40.83z M135.11,39.93c-0.1,0-0.2-0.05-0.25-0.15c-0.07-0.14-0.02-0.3,0.12-0.37 c0.28-0.14,0.55-0.28,0.83-0.42c0.14-0.07,0.3-0.01,0.37,0.13c0.07,0.14,0.01,0.3-0.13,0.37c-0.27,0.13-0.54,0.27-0.82,0.41 C135.2,39.92,135.16,39.93,135.11,39.93z M136.77,39.12c-0.1,0-0.2-0.06-0.25-0.16c-0.06-0.14,0-0.3,0.14-0.37 c0.28-0.13,0.57-0.26,0.85-0.38c0.14-0.06,0.3,0,0.36,0.14c0.06,0.14,0,0.3-0.14,0.36c-0.28,0.12-0.56,0.24-0.84,0.37 C136.85,39.11,136.81,39.12,136.77,39.12z M138.46,38.39c-0.11,0-0.21-0.07-0.26-0.17c-0.06-0.14,0.01-0.3,0.15-0.36 c0.29-0.12,0.58-0.23,0.86-0.34c0.14-0.05,0.3,0.02,0.36,0.16c0.05,0.14-0.02,0.3-0.16,0.36c-0.28,0.11-0.57,0.22-0.85,0.33 C138.53,38.38,138.49,38.39,138.46,38.39z M140.18,37.73c-0.11,0-0.22-0.07-0.26-0.18c-0.05-0.14,0.02-0.3,0.17-0.35 c0.3-0.11,0.59-0.21,0.88-0.3c0.14-0.05,0.3,0.03,0.35,0.18c0.05,0.14-0.03,0.3-0.18,0.35c-0.28,0.09-0.57,0.19-0.87,0.3 C140.24,37.73,140.21,37.73,140.18,37.73z M141.93,37.15c-0.12,0-0.23-0.08-0.26-0.19c-0.05-0.15,0.04-0.3,0.18-0.35 c0.3-0.09,0.6-0.18,0.89-0.26c0.15-0.04,0.3,0.04,0.34,0.19c0.04,0.15-0.04,0.3-0.19,0.34c-0.29,0.08-0.58,0.17-0.88,0.26 C141.99,37.15,141.96,37.15,141.93,37.15z M143.71,36.64c-0.12,0-0.23-0.08-0.27-0.21c-0.04-0.15,0.05-0.3,0.2-0.34 c0.31-0.08,0.61-0.16,0.9-0.23c0.15-0.04,0.3,0.06,0.33,0.2c0.04,0.15-0.06,0.3-0.2,0.33c-0.28,0.07-0.58,0.14-0.89,0.23 C143.75,36.64,143.73,36.64,143.71,36.64z M145.5,36.21c-0.13,0-0.24-0.09-0.27-0.22c-0.03-0.15,0.06-0.3,0.21-0.33 c0.33-0.07,0.63-0.14,0.91-0.19c0.15-0.03,0.29,0.07,0.32,0.22s-0.07,0.29-0.22,0.32c-0.27,0.05-0.57,0.12-0.9,0.19 C145.54,36.21,145.52,36.21,145.5,36.21z M147.31,35.86c-0.13,0-0.25-0.1-0.27-0.23c-0.03-0.15,0.08-0.29,0.23-0.32 c0.59-0.1,0.92-0.14,0.93-0.14c0.15-0.02,0.29,0.09,0.31,0.24c0.02,0.15-0.09,0.29-0.24,0.31c0,0-0.33,0.04-0.9,0.14 C147.34,35.85,147.33,35.86,147.31,35.86z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.59,50.97C99.59,50.97,99.59,50.97,99.59,50.97c-0.16,0-0.28-0.13-0.28-0.28c0.01-0.31,0.02-0.62,0.04-0.93 c0.01-0.15,0.14-0.27,0.29-0.26c0.15,0.01,0.27,0.14,0.26,0.29c-0.02,0.3-0.03,0.61-0.04,0.91C99.86,50.85,99.74,50.97,99.59,50.97 z M99.7,49.13c-0.01,0-0.02,0-0.03,0c-0.15-0.01-0.26-0.15-0.25-0.3c0.03-0.31,0.06-0.62,0.1-0.92c0.02-0.15,0.16-0.26,0.31-0.24 c0.15,0.02,0.26,0.16,0.24,0.31c-0.04,0.3-0.07,0.6-0.1,0.91C99.96,49.02,99.84,49.13,99.7,49.13z M99.93,47.3 c-0.01,0-0.03,0-0.04,0c-0.15-0.02-0.25-0.17-0.23-0.32c0.05-0.31,0.1-0.61,0.16-0.92c0.03-0.15,0.17-0.25,0.32-0.22 c0.15,0.03,0.25,0.17,0.22,0.32c-0.06,0.3-0.11,0.6-0.16,0.9C100.18,47.21,100.06,47.3,99.93,47.3z M100.29,45.5 c-0.02,0-0.04,0-0.06-0.01c-0.15-0.03-0.24-0.18-0.21-0.33c0.07-0.3,0.15-0.61,0.23-0.9c0.04-0.15,0.19-0.23,0.34-0.19 c0.15,0.04,0.23,0.19,0.19,0.34c-0.08,0.29-0.15,0.59-0.22,0.88C100.53,45.41,100.41,45.5,100.29,45.5z M100.77,43.72 c-0.03,0-0.05,0-0.08-0.01c-0.15-0.05-0.23-0.2-0.18-0.35c0.09-0.3,0.19-0.59,0.29-0.88c0.05-0.14,0.21-0.22,0.35-0.17 c0.14,0.05,0.22,0.21,0.17,0.35c-0.1,0.28-0.2,0.57-0.29,0.86C101,43.65,100.89,43.72,100.77,43.72z M101.38,41.99 c-0.03,0-0.07-0.01-0.1-0.02c-0.14-0.06-0.21-0.22-0.16-0.36c0.11-0.29,0.23-0.58,0.36-0.86c0.06-0.14,0.22-0.2,0.36-0.14 c0.14,0.06,0.2,0.22,0.14,0.36c-0.12,0.28-0.24,0.56-0.35,0.84C101.59,41.92,101.49,41.99,101.38,41.99z M102.11,40.3 c-0.04,0-0.08-0.01-0.12-0.03c-0.14-0.07-0.2-0.23-0.13-0.37c0.13-0.28,0.27-0.56,0.42-0.83c0.07-0.14,0.24-0.19,0.37-0.12 c0.14,0.07,0.19,0.24,0.12,0.37c-0.14,0.27-0.28,0.54-0.41,0.81C102.31,40.24,102.22,40.3,102.11,40.3z M102.97,38.67 c-0.05,0-0.09-0.01-0.14-0.04c-0.13-0.08-0.18-0.24-0.1-0.38c0.15-0.27,0.31-0.54,0.48-0.8c0.08-0.13,0.25-0.17,0.38-0.09 c0.13,0.08,0.17,0.25,0.09,0.38c-0.16,0.26-0.32,0.52-0.47,0.78C103.16,38.62,103.07,38.67,102.97,38.67z M103.94,37.11 c-0.05,0-0.11-0.02-0.15-0.05c-0.13-0.09-0.16-0.26-0.07-0.38c0.17-0.26,0.35-0.51,0.53-0.76c0.09-0.12,0.26-0.15,0.39-0.06 c0.12,0.09,0.15,0.26,0.06,0.39c-0.18,0.24-0.35,0.5-0.52,0.75C104.12,37.07,104.03,37.11,103.94,37.11z M105.03,35.62 c-0.06,0-0.12-0.02-0.17-0.06c-0.12-0.09-0.14-0.27-0.05-0.39c0.19-0.24,0.39-0.49,0.59-0.72c0.1-0.12,0.27-0.13,0.39-0.03 c0.12,0.1,0.13,0.27,0.03,0.39c-0.2,0.23-0.39,0.47-0.57,0.71C105.19,35.58,105.11,35.62,105.03,35.62z M106.21,34.21 c-0.07,0-0.13-0.02-0.18-0.07c-0.11-0.1-0.12-0.28-0.02-0.39c0.21-0.23,0.42-0.46,0.64-0.68c0.11-0.11,0.28-0.11,0.39-0.01 c0.11,0.11,0.11,0.28,0.01,0.39c-0.21,0.22-0.42,0.44-0.62,0.67C106.37,34.18,106.29,34.21,106.21,34.21z M107.5,32.89 c-0.07,0-0.14-0.03-0.2-0.08c-0.11-0.11-0.1-0.28,0.01-0.39c0.22-0.22,0.45-0.43,0.68-0.64c0.11-0.1,0.29-0.09,0.39,0.02 c0.1,0.11,0.09,0.29-0.02,0.39c-0.22,0.2-0.45,0.41-0.67,0.62C107.63,32.86,107.56,32.89,107.5,32.89z M108.86,31.65 c-0.08,0-0.16-0.03-0.21-0.1c-0.1-0.12-0.08-0.29,0.03-0.39c0.24-0.2,0.48-0.4,0.72-0.59c0.12-0.09,0.29-0.07,0.39,0.05 c0.09,0.12,0.07,0.29-0.05,0.39c-0.24,0.19-0.48,0.38-0.71,0.58C108.99,31.63,108.93,31.65,108.86,31.65z M110.32,30.51 c-0.09,0-0.17-0.04-0.22-0.11c-0.09-0.12-0.06-0.3,0.06-0.39c0.25-0.18,0.51-0.36,0.76-0.53c0.13-0.08,0.3-0.05,0.38,0.08 c0.08,0.13,0.05,0.3-0.08,0.38c-0.25,0.17-0.5,0.34-0.75,0.52C110.43,30.5,110.37,30.51,110.32,30.51z M111.85,29.49 c-0.09,0-0.18-0.05-0.24-0.13c-0.08-0.13-0.04-0.3,0.09-0.38c0.51-0.31,0.81-0.46,0.83-0.47c0.14-0.07,0.3-0.01,0.37,0.12 c0.07,0.14,0.01,0.3-0.12,0.37c0,0-0.3,0.15-0.79,0.45C111.95,29.47,111.9,29.49,111.85,29.49z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInteractivo);
export default __webpack_public_path__ + "static/media/icon_interactivo.941a3161cb1114953866f182a7e9cf41.svg";
export { ForwardRef as ReactComponent };